export const locationsList = [
    // Argentina
    {
        comuna: "Buenos Aires, toda la ciudad",
        long_name: "Buenos Aires, toda la ciudad",
        country: "Argentina",
        latitud: -34.6036844,
        longitud: -58.3815591,
        northeast: "-34.52654636106313,-58.33514472475672",
        southwest: "-34.70510112811848,-58.53145220760162",
        polygon: false,
        image_filename: "buenos_aires_toda_la_ciudad",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Buenos Aires, Almagro",
        long_name: "Buenos Aires, Almagro",
        country: "Argentina",
        latitud: -34.6114447,
        longitud: -58.4209936,
        northeast: "-34.59770274704947,-58.4119189485255",
        southwest: "-34.62207434590157,-58.43333402722834",
        polygon: true,
        image_filename: "buenos_aires_almagro",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, Belgrano",
        long_name: "Buenos Aires, Belgrano",
        country: "Argentina",
        latitud: -34.5620844,
        longitud: -58.4566864,
        northeast: "-34.5359311016451,-58.42820373959617",
        southwest: "-34.57500839276119,-58.47336842447922",
        polygon: true,
        image_filename: "buenos_aires_belgrano",
        search_query_enabled: true
    },
    {
        comuna: "Buenos Aires, Boedo",
        long_name: "Buenos Aires, Boedo",
        country: "Argentina",
        latitud: -34.6305379,
        longitud: -58.4192214,
        northeast: "-34.62064223061657,-58.41048865654462",
        southwest: "-34.64020022426429,-58.42779529821492",
        polygon: true,
        image_filename: "buenos_aires_boedo",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, Caballito",
        long_name: "Buenos Aires, Caballito",
        country: "Argentina",
        latitud: -34.6159245,
        longitud: -58.4406027,
        northeast: "-34.60267336034419,-58.42675582585225",
        southwest: "-34.63063906647759,-58.46270463067378",
        polygon: true,
        image_filename: "buenos_aires_caballito",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, Chacarita",
        long_name: "Buenos Aires, Chacarita",
        country: "Argentina",
        latitud: -34.5859985,
        longitud: -58.45443629999999,
        northeast: "-34.57829453869661,-58.43849764188068",
        southwest: "-34.59783466793689,-58.4669576235153",
        polygon: true,
        image_filename: "buenos_aires_chacarita",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, Colegiales",
        long_name: "Buenos Aires, Colegiales",
        country: "Argentina",
        latitud: -34.5760225,
        longitud: -58.4483554,
        northeast: "-34.5661081700822,-58.43993891105978",
        southwest: "-34.58319172322628,-58.46335554961188",
        polygon: true,
        image_filename: "buenos_aires_colegiales",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, Flores",
        long_name: "Buenos Aires, Flores",
        country: "Argentina",
        latitud: -34.6374837,
        longitud: -58.4601452,
        northeast: "-34.61388557303465,-58.43742236310418",
        southwest: "-34.65684135871686,-58.47780721653619",
        polygon: true,
        image_filename: "buenos_aires_flores",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, La Boca",
        long_name: "Buenos Aires, La Boca",
        country: "Argentina",
        latitud: -34.6344961,
        longitud: -58.36313370000001,
        northeast: "-34.62500414702805,-58.3527324774575",
        southwest: "-34.65017266519008,-58.37065825565539",
        polygon: true,
        image_filename: "buenos_aires_la_boca",
        search_query_enabled: true
    },
    {
        comuna: "Buenos Aires, Nuñez",
        long_name: "Buenos Aires, Nuñez",
        country: "Argentina",
        latitud: -34.5447906,
        longitud: -58.4598789,
        northeast: "-34.52654636106313,-58.44643338341963",
        southwest: "-34.55892837545181,-58.47575577415701",
        polygon: true,
        image_filename: "buenos_aires_nunez",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, Palermo",
        long_name: "Buenos Aires, Palermo",
        country: "Argentina",
        latitud: -34.5780655,
        longitud: -58.4265317,
        northeast: "-34.5490119771075,-58.39298649435829",
        southwest: "-34.59785472473616,-58.44904437613813",
        polygon: true,
        image_filename: "buenos_aires_palermo",
        search_query_enabled: true
    },
    {
        comuna: "Buenos Aires, Parque Patricios",
        long_name: "Buenos Aires, Parque Patricios",
        country: "Argentina",
        latitud: -34.6362319,
        longitud: -58.4004841,
        northeast: "-34.62725286228006,-58.38988142140611",
        southwest: "-34.64859488218676,-58.41343650917931",
        polygon: true,
        image_filename: "buenos_aires_parque_patricios",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, Puerto Madero",
        long_name: "Buenos Aires, Puerto Madero",
        country: "Argentina",
        latitud: -34.6177194,
        longitud: -58.3620561,
        northeast: "-34.59467401608841,-58.33514472475672",
        southwest: "-34.63257327938826,-58.36939299381784",
        polygon: true,
        image_filename: "buenos_aires_puerto_madero",
        search_query_enabled: true
    },
    {
        comuna: "Buenos Aires, Recoleta",
        long_name: "Buenos Aires, Recoleta",
        country: "Argentina",
        latitud: -34.5873825,
        longitud: -58.39727620000001,
        northeast: "-34.56989504893882,-58.3766853295508",
        southwest: "-34.59976039338088,-58.41600042107622",
        polygon: true,
        image_filename: "buenos_aires_recoleta",
        search_query_enabled: true
    },
    {
        comuna: "Buenos Aires, Retiro",
        long_name: "Buenos Aires, Retiro",
        country: "Argentina",
        latitud: -34.5896061,
        longitud: -58.3802473,
        northeast: "-34.57950283306921,-58.36566692499179",
        southwest: "-34.59929285922635,-58.38790973629558",
        polygon: true,
        image_filename: "buenos_aires_retiro",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, Saavedra",
        long_name: "Buenos Aires, Saavedra",
        country: "Argentina",
        latitud: -34.5545188,
        longitud: -58.4915986,
        northeast: "-34.53881614175945,-58.46818929604658",
        southwest: "-34.56988232735495,-58.51013033385347",
        polygon: true,
        image_filename: "buenos_aires_saavedra",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, San Telmo",
        long_name: "Buenos Aires, San Telmo",
        country: "Argentina",
        latitud: -34.6218351,
        longitud: -58.3713942,
        northeast: "-34.61562665028076,-58.36309091893586",
        southwest: "-34.62949370416774,-58.37742524370558",
        polygon: true,
        image_filename: "buenos_aires_san_telmo",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, Monserrat",
        long_name: "Buenos Aires, Monserrat",
        country: "Argentina",
        latitud: -34.6089,
        longitud: -58.3816,
        northeast: "-34.6020,-58.3730",
        southwest: "-34.6160,-58.3920",
        polygon: true,
        image_filename: "default",
        search_query_enabled: true
    },
    {
        comuna: "Buenos Aires, Villa Crespo",
        long_name: "Buenos Aires, Villa Crespo",
        country: "Argentina",
        latitud: -34.5947209,
        longitud: -58.4442897,
        northeast: "-34.58869051507484,-58.42336245346457",
        southwest: "-34.60761551591774,-58.45893473989321",
        polygon: true,
        image_filename: "buenos_aires_villa_crespo",
        search_query_enabled: false
    },
    {
        comuna: "Buenos Aires, Villa Urquiza",
        long_name: "Buenos Aires, Villa Urquiza",
        country: "Argentina",
        latitud: -34.5703983,
        longitud: -58.49138680000001,
        northeast: "-34.55910422895678,-58.46808126935032",
        southwest: "-34.58481817124689,-58.50941221855233",
        polygon: true,
        image_filename: "buenos_aires_villa_urquiza",
        search_query_enabled: false
    },
    {
        comuna: "Provincia de Buenos Aires, Mar del Plata",
        long_name: "Provincia de Buenos Aires, Mar del Plata",
        country: "Argentina",
        latitude: -38.0054771,
        longitude: -57.5426106,
        northeast: "-37.90878298257896,-57.51795201968563",
        southwest: "-38.12635032389073,-57.68311614064216",
        polygon: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Buenos Aires, La Plata",
        long_name: "Buenos Aires, La Plata",
        country: "Argentina",
        latitud: -34.92145,
        longitud: -57.95453,
        northeast: "-34.885,-57.900",
        southwest: "-34.960,-58.020",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Cordoba",
        long_name: "Cordoba",
        country: "Argentina",
        latitud: -31.42008329999999,
        longitud: -64.1887761,
        northeast: "-31.30646103489714,-64.06909932034236",
        southwest: "-31.49244535901042,-64.3193253509635",
        polygon: false,
        image_filename: "cordoba",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Mendoza",
        long_name: "Mendoza",
        country: "Argentina",
        latitud: -32.8894587,
        longitud: -68.8458386,
        northeast: "-32.8159953407433,-68.6989778112199",
        southwest: "-32.95121452510103,-68.94840178772135",
        polygon: false,
        image_filename: "mendoza",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Neuquén",
        long_name: "Neuquén",
        country: "Argentina",
        latitud: -38.9516784,
        longitud: -68.0591888,
        northeast: "-38.89328005153885,-68.00814816027368",
        southwest: "-38.98918905814746,-68.22265341538633",
        polygon: false,
        image_filename: "neuquen",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // Argentina
{
     comuna: "Salta",
    long_name: "Salta",
    country: "Argentina",
    latitud: -24.985650625602254,
    longitud: -64.86233122612978,
    northeast: "-22.72510924422399,-59.97890837456728",
    southwest: "-27.20538598774032,-69.74575407769228",
    polygon: false,
    image_filename: "default",
    search_query_enabled: true,
    home_search_query_enabled: true
},

    // Argentina - Bariloche
    {
        comuna: "Bariloche",
        long_name: "San Carlos de Bariloche",
        country: "Argentina",
        latitud: -41.133472,
        longitud: -71.310278,
        northeast: "-41.083,-71.24",
        southwest: "-41.183,-71.36",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },

    // Chile
    {
        comuna: "Santiago, Providencia",
        long_name: "Santiago, Providencia",
        country: "Chile",
        latitud: -33.4262806,
        longitud: -70.6151343,
        northeast: "-33.40341195293673,-70.58225018184636",
        southwest: "-33.44984106242084,-70.63624947294747",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Santiago, Ñuñoa",
        long_name: "Santiago, Ñuñoa",
        country: "Chile",
        latitud: -33.4549175,
        longitud: -70.5982915,
        northeast: "-33.43380044265094,-70.5707508537598",
        southwest: "-33.47495485253308,-70.63155961883908",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Puerto Montt",
        long_name: "Puerto Montt",
        country: "Chile",
        latitud: -41.4692863,
        longitud: -72.9427616,
        northeast: "-41.426,-72.876",
        southwest: "-41.523,-73.025",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Pucón",
        long_name: "Pucón",
        country: "Chile",
        latitud: -39.2822222,
        longitud: -71.9772222,
        northeast: "-39.270,-71.960",
        southwest: "-39.295,-71.995",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "La Serena",
        long_name: "La Serena",
        country: "Chile",
        latitud: -29.90453,
        longitud: -71.24894,
        northeast: "-29.870,-71.210",
        southwest: "-29.940,-71.290",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Coquimbo",
        long_name: "Coquimbo",
        country: "Chile",
        latitud: -29.9533,
        longitud: -71.3395,
        northeast: "-29.930,-71.310",
        southwest: "-29.980,-71.370",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    // Uruguay
    {
        comuna: "Montevideo",
        long_name: "Montevideo",
        country: "Uruguay",
        latitud: -34.9011127,
        longitud: -56.1645314,
        northeast: "-34.850,-56.100",
        southwest: "-34.950,-56.250",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Punta del Este",
        long_name: "Punta del Este",
        country: "Uruguay",
        latitud: -34.9613,
        longitud: -54.9537,
        northeast: "-34.930,-54.900",
        southwest: "-34.990,-55.000",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "José Ignacio",
        long_name: "José Ignacio",
        country: "Uruguay",
        latitud: -34.8497,
        longitud: -54.6647,
        northeast: "-34.840,-54.650",
        southwest: "-34.860,-54.680",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    // Paraguay
    {
        comuna: "Asunción",
        long_name: "Asunción",
        country: "Paraguay",
        latitud: -25.2637,
        longitud: -57.5759,
        northeast: "-25.250,-57.550",
        southwest: "-25.280,-57.600",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Barrio Bellavista",
        long_name: "Barrio Bellavista",
        country: "Chile",
        latitud: -33.4322222,
        longitud: -70.6363889,
        northeast: "-33.4308343197085,-70.63502466970849",
        southwest: "-33.4335322802915,-70.63772263029149",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Los ángeles",
        long_name: "Los ángeles",
        country: "Chile",
        latitud: -37.4697297,
        longitud: -72.3536605,
        northeast: "-37.424500,-72.291000",
        southwest: "-37.520200,-72.418300",
        polygon: false,
        image_filename: "default",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        //nueva ciudad agregada
        comuna: "Valle del Elqui",
        long_name: "Valle del Elqui",
        country: "Chile",
        latitud: -30.03005603312163,
        longitud: -70.71026368934326,
        northeast: "-30.01170000254847,-70.67232652503662",
        southwest: "-30.048408664939984,-70.7482008536499",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Barrio Italia",
        long_name: "Barrio Italia",
        country: "Chile",
        latitud: -33.4382715,
        longitud: -70.6410854,
        northeast: "-33.43597858629745,-70.63658439597023",
        southwest: "-33.44220483545023,-70.64470888629934",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: false
    },
    {
        comuna: "Barrio Lastarria",
        long_name: "Barrio Lastarria",
        country: "Chile",
        latitud: -33.43782629999999,
        longitud: -70.639476,
        northeast: "-33.4367501197085,-70.63866115",
        southwest: "-33.4394480802915,-70.64192055000001",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: false
    },
    {
        comuna: "Barrio Paris-Londres",
        long_name: "Barrio Paris-Londres",
        country: "Chile",
        latitud: -33.4446231,
        longitud: -70.64842879999999,
        northeast: "-33.44327411970851,-70.6470798197085",
        southwest: "-33.4459720802915,-70.6497777802915",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: false
    },
    {
        comuna: "Barrio Yungay",
        long_name: "Barrio Yungay",
        country: "Chile",
        latitud: -33.4429112,
        longitud: -70.6731231,
        northeast: "-33.4349023579793,-70.66759799269593",
        southwest: "-33.4507413769721,-70.68024566575444",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: false
    },
    {
        comuna: "Concepción",
        long_name: "Concepción",
        country: "Chile",
        latitud: -36.8201352,
        longitud: -73.0443904,
        northeast: "-36.76354254601518,-72.98195795982652",
        southwest: "-36.88854165008797,-73.08413320087756",
        polygon: false,
        image_filename: "concepcion",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Isla de Pascua",
        long_name: "Isla de Pascua",
        country: "Chile",
        latitud: -27.112723,
        longitud: -109.3496865,
        northeast: "-27.05473189047591,-109.2276952472208",
        southwest: "-27.19722795145251,-109.4499342192965",
        polygon: false,
        image_filename: "isla_de_pascua",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Las Condes",
        long_name: "Las Condes",
        country: "Chile",
        latitud: -33.4161088,
        longitud: -70.5340623,
        northeast: "-33.364206818506,-70.42728650953026",
        southwest: "-33.48606993664915,-70.60778616984688",
        polygon: false,
        image_filename: "concepcion",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "La Reina",
        long_name: "La Reina",
        country: "Chile",
        latitud: -33.4418601,
        longitud: -70.5345553,
        northeast: "-33.4288361198588,-70.51125278706823",
        southwest: "-33.46555683383467,-70.58451646547671",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: false
    },
    {
        comuna: "Lo Barnechea",
        long_name: "Lo Barnechea",
        country: "Chile",
        latitud: -33.3527172,
        longitud: -70.5185506,
        northeast: "-33.31175167016673,-70.42591376089433",
        southwest: "-33.37284987557622,-70.5753078428751",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Ñuñoa",
        long_name: "Ñuñoa",
        country: "Chile",
        latitud: -33.4549175,
        longitud: -70.5982915,
        northeast: "-33.43380044265094,-70.5707508537598",
        southwest: "-33.47495485253308,-70.63155961883908",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: false
    },   
    // {
    //     comuna: "Santiago de Chile, toda la ciudad",
    //     long_name: "Santiago de Chile, toda la ciudad",
    //     country: "Chile",
    //     latitud: -33.4488897,
    //     longitud: -70.6692655,
    //     northeast: "-33.27138735393422,-70.42678074132388",
    //     southwest: "-33.67418853776274,-70.83288189033638",
    //     polygon: false,
    //     image_filename: "santiago_de_chile_toda_la_ciudad",
    //     search_query_enabled: true,
    //     home_search_query_enabled: true
    // },
    {
        comuna: "Santiago de Chile, centro",
        long_name: "Santiago de Chile, centro",
        country: "Chile",
        latitud: -33.4452217,
        longitud: -70.6573657,
        northeast: "-33.42569401113151,-70.62505383537598",
        southwest: "-33.47855073404921,-70.69204190884864",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: false
    },
    {
        comuna: "Valparaíso",
        long_name: "Valparaíso",
        country: "Chile",
        latitud: -33.047238,
        longitud: -71.61268849999999,
        northeast: "-33.01781650321404,-71.55976843955561",
        southwest: "-33.08258438867568,-71.66232867881529",
        polygon: false,
        image_filename: "valparaiso",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Villarrica",
        long_name: "Villarrica",
        country: "Chile",
        latitud: -39.2827107,
        longitud: -72.2281654,
        northeast: "-39.27352484793295,-72.2175559749138",
        southwest: "-39.30073791512758,-72.24209236001334",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Viña del Mar",
        long_name: "Viña del Mar",
        country: "Chile",
        latitud: -33.0153481,
        longitud: -71.55002759999999,
        northeast: "-32.94845543653869,-71.47230798146632",
        southwest: "-33.06260243153779,-71.58820312328348",
        polygon: false,
        image_filename: "vina_del_mar",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Vitacura",
        long_name: "Vitacura",
        country: "Chile",
        latitud: -33.3903016,
        longitud: -70.5722938,
        northeast: "-33.35854128296734,-70.517633124786",
        southwest: "-33.4089482296152,-70.61014092840982",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // España
    {
        comuna: "Alicante",
        long_name: "Alicante (Alacant)",
        country: "España",
        latitud: 38.3457685,
        longitud: -0.4909444,
        northeast: "38.39093284211179,-0.4034190600039416",
        southwest: "38.32474877136838,-0.5416292294459696",
        polygon: false,
        image_filename: "alicante_alacant",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // Colombia
    {
        comuna: "Bogotá",
        long_name: "Bogotá",
        country: "Colombia",
        latitud: 4.710988599999999,
        longitud: -74.072092,
        northeast: "4.837131061187439,-73.99197704523905",
        southwest: "4.459464006095289,-74.22363695548903",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: false
    },
    // Barcelona
    {
        comuna: "Barcelona, toda la ciudad",
        long_name: "Barcelona, toda la ciudad",
        country: "España",
        latitud: 41.3873974,
        longitud: 2.168568,
        northeast: "41.4682974272428,2.22804492421789",
        southwest: "41.31703848925413,2.052333262952554",
        polygon: false,
        image_filename: "barcelona_toda_la_ciudad",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Barcelona, Barrio Gòtico",
        long_name: "Barcelona, Barrio Gòtico",
        country: "España",
        latitud: 41.3819247,
        longitud: 2.1773052,
        northeast: "41.3884704503044,2.18499288523822",
        southwest: "41.37431452544303,2.169963258058956",
        polygon: true,
        image_filename: "barcelona_barrio_gotico",
        search_query_enabled: false
    },
    {
        comuna: "Barcelona, Eixample",
        long_name: "Barcelona, Eixample",
        country: "España",
        latitud: 41.3922586,
        longitud: 2.1650273,
        northeast: "41.41203643993794,2.186895379836445",
        southwest: "41.37497616158768,2.142302787122405",
        polygon: true,
        image_filename: "barcelona_eixample",
        search_query_enabled: true
    },
    {
        comuna: "Barcelona, El Poble-sec",
        long_name: "Barcelona, El Poble-sec",
        country: "España",
        latitud: 41.3725602,
        longitud: 2.1675332,
        northeast: "41.37500872056058,2.176302253314217",
        southwest: "41.36874607379767,2.153527809502968",
        polygon: true,
        image_filename: "barcelona_el_poble_sec",
        search_query_enabled: false
    },
    {
        comuna: "Barcelona, Les Corts",
        long_name: "Barcelona, Les Corts",
        country: "España",
        latitud: 41.38447,
        longitud: 2.1107283,
        northeast: "41.4011141071795,2.14434435000822",
        southwest: "41.3756736761727,2.097791852862739",
        polygon: true,
        image_filename: "barcelona_les_corts",
        search_query_enabled: true
    },
    {
        comuna: "Barcelona, Sant Gervasi-La Bonanova",
        long_name: "Barcelona, Sant Gervasi-La Bonanova",
        country: "España",
        latitud: 41.411538,
        longitud: 2.1323095,
        northeast: "41.41993314975943,2.140734849506438",
        southwest: "41.39934117635848,2.118825718778936",
        polygon: true,
        image_filename: "barcelona_sant_gervasi_la_bonanova",
        search_query_enabled: true
    },
    {
        comuna: "Barcelona, Sant Martí",
        long_name: "Barcelona, Sant Martí",
        country: "España",
        latitud: 41.4100098,
        longitud: 2.2029804,
        northeast: "41.43017620218451,2.22804492421789",
        southwest: "41.38335232726796,2.175467670142995",
        polygon: true,
        image_filename: "barcelona_sant_marti",
        search_query_enabled: false
    },

    {
        comuna: "Bilbao",
        long_name: "Bilbao",
        country: "España",
        latitud: 43.2630126,
        longitud: -2.9349852,
        northeast: "43.28914596491534,-2.889762865922365",
        southwest: "43.23750095589353,-2.977365936169626",
        polygon: false,
        image_filename: "bilbao",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Burgos",
        long_name: "Burgos",
        country: "España",
        latitud: 42.3504659,
        longitud: -3.689354499999999,
        northeast: "42.37213414784006,-3.636750412665408",
        southwest: "42.31611786603707,-3.752635747130636",
        polygon: false,
        image_filename: "burgos",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Cartagena",
        long_name: "Cartagena",
        country: "España",
        latitud: 37.6253022,
        longitud: -0.9972219,
        northeast: "37.63971015232394,-0.9642879391170617",
        southwest: "37.5951130761385,-1.012726866200791",
        polygon: false,
        image_filename: "cartagena",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Castellón de la Plana",
        long_name: "Castellón de la Plana",
        country: "España",
        latitud: 39.9863563,
        longitud: -0.0513246,
        northeast: "40.0300,0.0050",
        southwest: "39.9400,-0.0950",
        polygon: false,
        image_filename: "castellon_de_la_plana",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Granada",
        long_name: "Granada",
        country: "España",
        latitude: 37.1824607,
        longitude: -3.601167599999999,
        northeast: "37.21246481608327,-3.548708401659145",
        southwest: "37.14942766627898,-3.633835119344597",
        polygon: false,
        image_filename: "granada",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Huelva",
        long_name: "Huelva",
        country: "España",
        latitud: 37.2619585,
        longitud: -6.9427327,
        northeast: "37.2913206816194,-6.916788935877258",
        southwest: "37.1,-7.5",
        polygon: false,
        image_filename: "huelva",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Logroño",
        long_name: "Logroño",
        country: "España",
        latitud: 42.4627195,
        longitud: -2.4449852,
        northeast: "42.48168460944743,-2.411083724058472",
        southwest: "42.43890102668015,-2.485641679308714",
        polygon: false,
        image_filename: "logrono",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Lugo",
        long_name: "Lugo",
        country: "España",
        latitud: 43.0097384,
        longitud: -7.5567582,
        northeast: "43.03479856030992,-7.536812134553496",
        southwest: "42.9897686530195,-7.57618807393249",
        polygon: false,
        image_filename: "lugo",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // Madrid
    {
        comuna: "Madrid, toda la ciudad",
        long_name: "Madrid, toda la ciudad",
        country: "España",
        latitud: 40.4167754,
        longitud: -3.7037902,
        northeast: "40.56384473341083,-3.524911528167741",
        southwest: "40.31206394740597,-3.834161809872056",
        polygon: false,
        image_filename: "madrid_toda_la_ciudad",
        search_query_enabled: true,
        home_search_query_enabled: true
    },
    {
        comuna: "Madrid, Centro",
        long_name: "Madrid, Centro",
        country: "España",
        latitud: 40.4167234,
        longitud: -3.7033851,
        northeast: "40.43061606023851,-3.690288963431012",
        southwest: "40.40504105097957,-3.72287807086027",
        polygon: true,
        image_filename: "madrid_centro",
        search_query_enabled: false
    },
    {
        comuna: "Madrid, Chamartín",
        long_name: "Madrid, Chamartín",
        country: "España",
        latitud: 40.4615174,
        longitud: -3.6865844,
        northeast: "40.48406098931166,-3.660459748722928",
        southwest: "40.43740197218633,-3.691642947174351",
        polygon: true,
        image_filename: "madrid_chamartin",
        search_query_enabled: false
    },
    {
        comuna: "Madrid, Chamberí",
        long_name: "Madrid, Chamberí",
        country: "España",
        latitud: 40.4344286,
        longitud: -3.7131782,
        northeast: "40.44714298465772,-3.688332051908287",
        southwest: "40.42525499283333,-3.719855724175303",
        polygon: true,
        image_filename: "madrid_chamberi",
        search_query_enabled: true
    },
    {
        comuna: "Madrid, Retiro",
        long_name: "Madrid, Retiro",
        country: "España",
        latitud: 40.4113349,
        longitud: -3.6749081,
        northeast: "40.42170803907248,-3.658618015710902",
        southwest: "40.39435987342883,-3.693576918675043",
        polygon: true,
        image_filename: "madrid_retiro",
        search_query_enabled: true
    },
    {
        comuna: "Madrid, Salamanca",
        long_name: "Madrid, Salamanca",
        country: "España",
        latitud: 40.4279488,
        longitud: -3.68675,
        northeast: "40.44464290492917,-3.658618015710902",
        southwest: "40.41863194812891,-3.692713960679216",
        polygon: true,
        image_filename: "madrid_salamanca",
        search_query_enabled: true
    },

    {
        comuna: "Málaga",
        long_name: "Málaga",
        country: "España",
        latitud: 36.721213,
        longitud: -4.4216879,
        northeast: "36.75755262609146,-4.339496540648535",
        southwest: "36.67889138816003,-4.559037314171312",
        polygon: false,
        image_filename: "malaga",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Oviedo",
        long_name: "Oviedo",
        country: "España",
        latitud: 43.3622522,
        longitud: -5.8485461,
        northeast: "43.39203855924637,-5.812127239770163",
        southwest: "43.34693506623958,-5.885188444013071",
        polygon: false,
        image_filename: "oviedo",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Pamplona",
        long_name: "Pamplona",
        country: "España",
        latitud: 42.812526,
        longitud: -1.6457745,
        northeast: "42.83811756569991,-1.604659160572587",
        southwest: "42.79341437009327,-1.695384048112043",
        polygon: false,
        image_filename: "pamplona",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Salamanca",
        long_name: "Salamanca",
        country: "España",
        latitud: 40.9701039,
        longitud: -5.663539699999999,
        northeast: "40.98509709418802,-5.631203931940572",
        southwest: "40.94177994596159,-5.707220262223757",
        polygon: false,
        image_filename: "salamanca",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "San Sebastián",
        long_name: "San Sebastián",
        country: "España",
        latitud: 43.318334,
        longitud: -1.9812313,
        northeast: "43.32871430102026,-1.924211465519547",
        southwest: "43.2858710377457,-2.023554449750387",
        polygon: false,
        image_filename: "san_sebastian",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Santander",
        long_name: "Santander",
        country: "España",
        latitud: 43.4636346,
        longitud: -3.8226402,
        northeast: "43.48639082374222,-3.753610862903355",
        southwest: "43.43629802556797,-3.868663249176218",
        polygon: false,
        image_filename: "santander",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Segovia",
        long_name: "Segovia",
        country: "España",
        latitude: 40.9429032,
        longitude: -4.108806899999999,
        northeast: "40.96250166650696,-4.090817022707955",
        southwest: "40.91999864796654,-4.133586824536152",
        polygon: true,
        image_filename: "segovia",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Sevilla",
        long_name: "Sevilla",
        country: "España",
        latitud: 37.3890924,
        longitud: -5.9844589,
        northeast: "37.43552116934161,-5.888458652078246",
        southwest: "37.31522026882898,-6.021657814478962",
        polygon: false,
        image_filename: "sevilla",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // Valencia
    {
        comuna: "Valencia, toda la ciudad",
        long_name: "Valencia, toda la ciudad",
        country: "España",
        latitud: 39.4699075,
        longitud: -0.3762881,
        northeast: "39.5073224594516,-0.2914778120622837",
        southwest: "39.30824799722067,-0.4315448083676902",
        polygon: false,
        image_filename: "valencia_toda_la_ciudad",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Valencia, Ayora",
        long_name: "Valencia, Ayora",
        country: "España",
        latitud: 39.4665282,
        longitud: -0.3430688,
        northeast: "39.46972199221864,-0.3353839679034252",
        southwest: "39.46176506550147,-0.35129801636527",
        polygon: true,
        image_filename: "valencia_ayora",
        search_query_enabled: false
    },
    {
        comuna: "Valencia, Camins al Grau",
        long_name: "Valencia, Camins al Grau",
        country: "España",
        latitud: 39.4626283,
        longitud: -0.3489496,
        northeast: "39.47147698763202,-0.3353839679034252",
        southwest: "39.45377305841663,-0.3609381645184877",
        polygon: true,
        image_filename: "valencia_camins_al_grau",
        search_query_enabled: false
    },
    {
        comuna: "Valencia, Quatre Carreres",
        long_name: "Valencia, Quatre Carreres",
        country: "España",
        latitud: 39.44964909999999,
        longitud: -0.3607137,
        northeast: "39.46314689388979,-0.3345368354468051",
        southwest: "39.42602901665821,-0.3868677389683054",
        polygon: true,
        image_filename: "valencia_quatre_carreres",
        search_query_enabled: false
    },
    {
        comuna: "Valencia, Poblats Maritims",
        long_name: "Valencia, Poblats Maritims",
        country: "España",
        latitud: 39.45232850000001,
        longitud: -0.3301342,
        northeast: "39.48589403033223,-0.302151860409177",
        southwest: "39.42277194247347,-0.3416658356009217",
        polygon: true,
        image_filename: "valencia_poblats_maritims",
        search_query_enabled: false
    },
    {
        comuna: "Valladolid",
        long_name: "Valladolid",
        country: "España",
        latitude: 41.6543639,
        longitude: -4.722273299999999,
        northeast: "41.81550857174353,-4.689443915306096",
        southwest: "41.5909982535988,-4.928180310147945",
        polygon: true,
        image_filename: "valladolid",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // Italy
    {
        comuna: "Milán",
        long_name: "Milán",
        country: "Italy",
        latitud: 45.4642035,
        longitud: 9.189982,
        northeast: "45.5350,9.2780",
        southwest: "45.3860,9.0400",
        polygon: false,
        image_filename: "milan",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Roma",
        long_name: "Roma",
        country: "Italy",
        latitud: 41.9027835,
        longitud: 12.4963655,
        // El northeast sube de 42.0500 a 42.0754 para absorber el cluster que
        // el import de Spacest había creado como zona aparte, también "Roma".
        northeast: "42.0754,12.7300",
        southwest: "41.7600,12.3400",
        polygon: false,
        image_filename: "rome",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Florencia",
        long_name: "Florencia",
        country: "Italy",
        latitud: 43.7695604,
        longitud: 11.2558136,
        northeast: "43.8350,11.3300",
        southwest: "43.7250,11.1700",
        polygon: false,
        image_filename: "florence",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Turín",
        long_name: "Turín",
        country: "Italy",
        latitud: 45.070312,
        longitud: 7.6868565,
        northeast: "45.1350,7.7700",
        southwest: "45.0050,7.5800",
        polygon: false,
        image_filename: "turin",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Bologna",
        long_name: "Bologna",
        country: "Italy",
        latitud: 44.494887,
        longitud: 11.3426163,
        northeast: "44.5600,11.4300",
        southwest: "44.4300,11.2500",
        polygon: false,
        image_filename: "bologna",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // Germany
    {
        comuna: "Berlin",
        long_name: "Berlin",
        country: "Germany",
        latitud: 52.5200066,
        longitud: 13.404954,
        northeast: "52.6755,13.7611",
        southwest: "52.3382,13.0884",
        polygon: false,
        image_filename: "berlin",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Frankfurt",
        long_name: "Frankfurt",
        country: "Germany",
        latitud: 50.1109221,
        longitud: 8.6821267,
        northeast: "50.2270,8.8000",
        southwest: "50.0150,8.4700",
        polygon: false,
        image_filename: "frankfurt",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Múnich",
        long_name: "Múnich",
        country: "Germany",
        latitud: 48.1351253,
        longitud: 11.5819806,
        northeast: "48.2480,11.7220",
        southwest: "48.0610,11.3600",
        polygon: false,
        image_filename: "munich",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Düsseldorf",
        long_name: "Düsseldorf",
        country: "Germany",
        latitud: 51.2277411,
        longitud: 6.7734556,
        northeast: "51.3520,6.9400",
        southwest: "51.1250,6.6600",
        polygon: false,
        image_filename: "dusseldorf",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Stuttgart",
        long_name: "Stuttgart",
        country: "Germany",
        latitud: 48.7758459,
        longitud: 9.1829321,
        northeast: "48.8650,9.3150",
        southwest: "48.6900,9.0400",
        polygon: false,
        image_filename: "stuttgart",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // France
    {
        comuna: "Paris",
        long_name: "Paris",
        country: "France",
        latitud: 48.856614,
        longitud: 2.3522219,
        northeast: "48.9022,2.4699",
        southwest: "48.8156,2.2241",
        polygon: false,
        image_filename: "paris",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Lille",
        long_name: "Lille",
        country: "France",
        latitud: 50.62925,
        longitud: 3.057256,
        northeast: "50.6610,3.1250",
        southwest: "50.6000,2.9850",
        polygon: false,
        image_filename: "lille",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Bordeaux",
        long_name: "Bordeaux",
        country: "France",
        latitud: 44.837789,
        longitud: -0.57918,
        northeast: "44.9160,-0.4800",
        southwest: "44.7850,-0.6900",
        polygon: false,
        image_filename: "bordeaux",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Toulouse",
        long_name: "Toulouse",
        country: "France",
        latitud: 43.604652,
        longitud: 1.444209,
        northeast: "43.6680,1.5150",
        southwest: "43.5350,1.3500",
        polygon: false,
        image_filename: "toulouse",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // Netherlands
    {
        comuna: "Amsterdam",
        long_name: "Amsterdam",
        country: "Netherlands",
        latitud: 52.3675734,
        longitud: 4.9041389,
        northeast: "52.4300,5.0800",
        southwest: "52.2780,4.7280",
        polygon: false,
        image_filename: "amsterdam",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Den Haag",
        long_name: "Den Haag",
        country: "Netherlands",
        latitud: 52.0704978,
        longitud: 4.3006999,
        northeast: "52.1350,4.4200",
        southwest: "52.0100,4.1800",
        polygon: false,
        image_filename: "den_haag",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // Austria
    {
        comuna: "Viena",
        long_name: "Viena",
        country: "Austria",
        latitud: 48.2081743,
        longitud: 16.3738189,
        northeast: "48.3220,16.5770",
        southwest: "48.1180,16.1820",
        polygon: false,
        image_filename: "vienna",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Graz",
        long_name: "Graz",
        country: "Austria",
        latitud: 47.070714,
        longitud: 15.439504,
        northeast: "47.1250,15.5150",
        southwest: "47.0200,15.3500",
        polygon: false,
        image_filename: "graz",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // United-Kingdom
    {
        comuna: "Londres",
        long_name: "Londres",
        country: "United-Kingdom",
        latitud: 51.5072178,
        longitud: -0.1275862,
        northeast: "51.6723,0.1483",
        southwest: "51.3849,-0.3515",
        polygon: false,
        image_filename: "londres",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // México
    {
        comuna: "D.F. México",
        long_name: "D.F. México",
        country: "Mexico",
        latitud: 19.2464696,
        longitud: -99.1013498,
        northeast: "19.59275714055156,-98.94030274603077",
        southwest: "19.04823658558244,-99.36492415078024",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: false
    },
    // Panamá
    {
        comuna: "Ciudad de Panamá",
        long_name: "Ciudad de Panamá",
        country: "Panamá",
        latitud: 8.9823792,
        longitud: -79.51986959999999,
        northeast: "9.259696609737304,-79.30689406194774",
        southwest: "8.90313381534501,-79.59938042427454",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false,
        home_search_query_enabled: false
    },
    // Perú
    {
        comuna: "Lima",
        long_name: "Lima",
        country: "Perú",
        latitud: -12.0463731,
        longitud: -77.042754,
        northeast: "-11.79998745006646,-76.78833965163773",
        southwest: "-12.25328905340461,-77.18721856505658",
        polygon: false,
        image_filename: "lima",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // Portugal
    {
        comuna: "Lisboa",
        long_name: "Lisboa",
        country: "Portugal",
        latitud: 38.7222524,
        longitud: -9.1393366,
        northeast: "38.7950,-9.0900",
        southwest: "38.6900,-9.2300",
        polygon: false,
        image_filename: "lisbon",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Braga",
        long_name: "Braga",
        country: "Portugal",
        latitud: 41.5454486,
        longitud: -8.426506999999999,
        northeast: "41.58414768853574,-8.342179110418417",
        southwest: "41.51040203529377,-8.480663286579226",
        polygon: false,
        image_filename: "braga",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Covilhã",
        long_name: "Covilhã",
        country: "Portugal",
        latitud: 40.2805633,
        longitud: -7.504327199999999,
        northeast: "40.31497336750819,-7.464640958209947",
        southwest: "40.256491553217,-7.537834777061322",
        polygon: false,
        image_filename: "covilha",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Coimbra",
        long_name: "Coimbra",
        country: "Portugal",
        latitud: 40.2033145,
        longitud: -8.4102573,
        northeast: "40.2400,-8.3500",
        southwest: "40.1750,-8.4600",
        polygon: false,
        image_filename: "coimbra",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Oporto",
        long_name: "Oporto",
        country: "Portugal",
        latitud: 41.1579438,
        longitud: -8.629105299999999,
        northeast: "41.18602848569317,-8.552613373962807",
        southwest: "41.13835060908927,-8.691293920826338",
        polygon: false,
        image_filename: "oporto",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    {
        comuna: "Vila Nova de Gaia",
        long_name: "Vila Nova de Gaia",
        country: "Portugal",
        latitud: 41.1238759,
        longitud: -8.6117851,
        northeast: "41.1700,-8.5500",
        southwest: "41.0500,-8.7000",
        polygon: false,
        image_filename: "vila_nova_de_gaia",
        search_query_enabled: false,
        home_search_query_enabled: true
    },
    // ---------------------------------------------------------------
    // Zonas generadas para cubrir el inventario de Spacest.
    // Centro y bounding box calculados a partir de los alojamientos del
    // feed que no caían en ninguna zona previa.
    // ---------------------------------------------------------------
    {
        comuna: "Saint-Denis",
        long_name: "Saint-Denis",
        country: "France",
        latitud: 48.8505106,
        longitud: 2.3263989,
        northeast: "49.0392,2.6174",
        southwest: "48.6079,1.9830",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Villeurbanne",
        long_name: "Villeurbanne",
        country: "France",
        latitud: 45.7501303,
        longitud: 4.8730661,
        northeast: "45.8296,4.9450",
        southwest: "45.6602,4.7090",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Padova",
        long_name: "Padova",
        country: "Italy",
        latitud: 45.4127428,
        longitud: 11.8813816,
        northeast: "45.4598,11.9744",
        southwest: "45.3329,11.8170",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Budapest",
        long_name: "Budapest",
        country: "Hungary",
        latitud: 47.4989554,
        longitud: 19.065204,
        northeast: "47.5249,19.0960",
        southwest: "47.4714,19.0217",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Como",
        long_name: "Como",
        country: "Switzerland",
        latitud: 45.9244025,
        longitud: 9.0294123,
        northeast: "46.1464,9.3811",
        southwest: "45.7779,8.8128",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Modena",
        long_name: "Modena",
        country: "Italy",
        latitud: 44.6430999,
        longitud: 10.9281615,
        northeast: "44.6681,10.9603",
        southwest: "44.6165,10.8936",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Napoli",
        long_name: "Napoli",
        country: "Italy",
        latitud: 40.8473349,
        longitud: 14.2500014,
        northeast: "40.9063,14.3021",
        southwest: "40.7921,14.1206",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Trento",
        long_name: "Trento",
        country: "Italy",
        latitud: 46.0662362,
        longitud: 11.1218326,
        northeast: "46.1092,11.1498",
        southwest: "46.0035,11.1022",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Brescia",
        long_name: "Brescia",
        country: "Italy",
        latitud: 45.5506139,
        longitud: 10.2264873,
        northeast: "45.5780,10.2598",
        southwest: "45.5157,10.1836",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cascais",
        long_name: "Cascais",
        country: "Portugal",
        latitud: 38.721809,
        longitud: -9.329418,
        northeast: "39.0533,-8.9431",
        southwest: "38.5712,-9.4903",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Trieste",
        long_name: "Trieste",
        country: "Italy",
        latitud: 45.6508812,
        longitud: 13.7765134,
        northeast: "45.6803,13.8030",
        southwest: "45.6246,13.7495",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Albufeira",
        long_name: "Albufeira",
        country: "Portugal",
        latitud: 37.0849549,
        longitud: -8.2360939,
        northeast: "37.1802,-7.8201",
        southwest: "36.9991,-8.7412",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pisa",
        long_name: "Pisa",
        country: "Italy",
        latitud: 43.7129237,
        longitud: 10.4142308,
        northeast: "43.8841,10.5950",
        southwest: "43.5052,10.2704",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Zaragoza",
        long_name: "Zaragoza",
        country: "España",
        latitud: 41.6470344,
        longitud: -0.8992994,
        northeast: "41.6700,-0.8778",
        southwest: "41.6288,-0.9248",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Madrid (alrededores)",
        long_name: "Madrid (alrededores)",
        country: "España",
        latitud: 40.3301789,
        longitud: -3.7694411,
        northeast: "40.4847,-3.7049",
        southwest: "40.2529,-3.8887",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Genova",
        long_name: "Genova",
        country: "Italy",
        latitud: 44.3758617,
        longitud: 9.0602948,
        northeast: "44.4408,9.5929",
        southwest: "44.1758,8.8860",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cagliari",
        long_name: "Cagliari",
        country: "Italy",
        latitud: 39.2219648,
        longitud: 9.1190623,
        northeast: "39.2476,9.2240",
        southwest: "39.1862,9.0928",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Nantes",
        long_name: "Nantes",
        country: "France",
        latitud: 47.2254057,
        longitud: -1.5686773,
        northeast: "47.2726,-1.4991",
        southwest: "47.1738,-1.6654",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Gdańsk",
        long_name: "Gdańsk",
        country: "Poland",
        latitud: 54.3673493,
        longitud: 18.6455053,
        northeast: "54.4507,18.6792",
        southwest: "54.3319,18.5579",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bruxelles",
        long_name: "Bruxelles",
        country: "Belgium",
        latitud: 50.8378633,
        longitud: 4.3715493,
        northeast: "50.8794,4.4128",
        southwest: "50.7619,4.3266",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Reims",
        long_name: "Reims",
        country: "France",
        latitud: 49.2530419,
        longitud: 4.0339535,
        northeast: "49.2838,4.0711",
        southwest: "49.2237,4.0075",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Venezia",
        long_name: "Venezia",
        country: "Italy",
        latitud: 45.4967967,
        longitud: 12.2466569,
        northeast: "45.7091,12.3486",
        southwest: "45.4160,12.1432",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Strasbourg",
        long_name: "Strasbourg",
        country: "France",
        latitud: 48.5823446,
        longitud: 7.755862,
        northeast: "48.6112,7.7905",
        southwest: "48.5144,7.6848",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Hamburg",
        long_name: "Hamburg",
        country: "Germany",
        latitud: 53.5677746,
        longitud: 9.9796097,
        northeast: "53.6658,10.1550",
        southwest: "53.3953,9.7505",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Monza",
        long_name: "Monza",
        country: "Italy",
        latitud: 45.5532604,
        longitud: 9.2223684,
        northeast: "45.6979,9.5210",
        southwest: "45.4231,8.7820",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Verona",
        long_name: "Verona",
        country: "Italy",
        latitud: 45.4350484,
        longitud: 10.986978,
        northeast: "45.4762,11.0357",
        southwest: "45.3862,10.8405",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Grenoble",
        long_name: "Grenoble",
        country: "France",
        latitud: 45.1770744,
        longitud: 5.7219183,
        northeast: "45.2182,5.7770",
        southwest: "45.1467,5.6524",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Brest",
        long_name: "Brest",
        country: "France",
        latitud: 48.3977915,
        longitud: -4.4941242,
        northeast: "48.4183,-4.4462",
        southwest: "48.3701,-4.5458",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Rennes",
        long_name: "Rennes",
        country: "France",
        latitud: 48.1019223,
        longitud: -1.6811639,
        northeast: "48.1499,-1.6412",
        southwest: "48.0741,-1.7633",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Valencia (alrededores)",
        long_name: "Valencia (alrededores)",
        country: "España",
        latitud: 39.5049172,
        longitud: -0.4193473,
        northeast: "39.5772,-0.3229",
        southwest: "39.4227,-0.4820",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Köln",
        long_name: "Köln",
        country: "Germany",
        latitud: 50.8838719,
        longitud: 6.9913974,
        northeast: "51.0179,7.1789",
        southwest: "50.6870,6.7886",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Tavira",
        long_name: "Tavira",
        country: "Portugal",
        latitud: 37.1359549,
        longitud: -7.6088825,
        northeast: "37.1871,-7.4918",
        southwest: "37.0922,-7.7259",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Roubaix",
        long_name: "Roubaix",
        country: "France",
        latitud: 50.6912627,
        longitud: 3.1668229,
        northeast: "50.7391,3.2003",
        southwest: "50.6547,3.1344",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Nancy",
        long_name: "Nancy",
        country: "France",
        latitud: 48.6837246,
        longitud: 6.1759327,
        northeast: "48.7110,6.2048",
        southwest: "48.6165,6.0691",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pescara",
        long_name: "Pescara",
        country: "Italy",
        latitud: 42.4580558,
        longitud: 14.2188202,
        northeast: "42.5042,14.2355",
        southwest: "42.4395,14.1728",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Málaga (alrededores)",
        long_name: "Málaga (alrededores)",
        country: "España",
        latitud: 36.5462824,
        longitud: -4.6384472,
        northeast: "36.6387,-4.4850",
        southwest: "36.4786,-4.7806",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Saint-Étienne",
        long_name: "Saint-Étienne",
        country: "France",
        latitud: 45.4367677,
        longitud: 4.3909996,
        northeast: "45.4860,4.5317",
        southwest: "45.4025,4.3669",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Forlì",
        long_name: "Forlì",
        country: "Italy",
        latitud: 44.2195637,
        longitud: 12.0461981,
        northeast: "44.2666,12.0679",
        southwest: "44.1995,12.0073",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Marseille",
        long_name: "Marseille",
        country: "France",
        latitud: 43.292245,
        longitud: 5.39288,
        northeast: "43.3432,5.4309",
        southwest: "43.2377,5.3465",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sassari",
        long_name: "Sassari",
        country: "Italy",
        latitud: 40.7211449,
        longitud: 8.5634104,
        northeast: "40.7400,8.5861",
        southwest: "40.7055,8.5438",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Essen-Stadtbezirke I",
        long_name: "Essen-Stadtbezirke I",
        country: "Germany",
        latitud: 51.4579033,
        longitud: 7.0114868,
        northeast: "51.4729,7.0397",
        southwest: "51.3647,6.8680",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Madrid (alrededores) 2",
        long_name: "Madrid (alrededores) 2",
        country: "España",
        latitud: 40.4789579,
        longitud: -3.3669771,
        northeast: "40.4979,-3.3442",
        southwest: "40.4640,-3.3897",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Tarragona",
        long_name: "Tarragona",
        country: "España",
        latitud: 41.1525398,
        longitud: 1.1075414,
        northeast: "41.1672,1.1225",
        southwest: "41.1371,1.0870",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bormio",
        long_name: "Bormio",
        country: "Italy",
        latitud: 46.4600637,
        longitud: 10.3734498,
        northeast: "46.4956,10.5064",
        southwest: "46.3954,10.3307",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Annemasse",
        long_name: "Annemasse",
        country: "France",
        latitud: 46.1906658,
        longitud: 6.2297186,
        northeast: "46.2120,6.2594",
        southwest: "46.1517,6.1730",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Alassio",
        long_name: "Alassio",
        country: "Italy",
        latitud: 44.0213554,
        longitud: 8.1845988,
        northeast: "44.2344,8.4253",
        southwest: "43.8857,8.0467",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Copenhague",
        long_name: "Copenhague",
        country: "Denmark",
        latitud: 55.6770116,
        longitud: 12.5537923,
        northeast: "55.7191,12.6210",
        southwest: "55.6352,12.5033",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Palermo",
        long_name: "Palermo",
        country: "Italy",
        latitud: 38.1149041,
        longitud: 13.3614377,
        northeast: "38.1418,13.3825",
        southwest: "38.0339,13.2886",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Leipzig",
        long_name: "Leipzig",
        country: "Germany",
        latitud: 51.3452056,
        longitud: 12.3691079,
        northeast: "51.3590,12.4084",
        southwest: "51.2995,12.2247",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Liège",
        long_name: "Liège",
        country: "Belgium",
        latitud: 50.62239,
        longitud: 5.5814634,
        northeast: "50.6559,5.5979",
        southwest: "50.6092,5.5599",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Novara",
        long_name: "Novara",
        country: "Italy",
        latitud: 45.4467926,
        longitud: 8.6282281,
        northeast: "45.4584,8.6494",
        southwest: "45.4338,8.6140",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Rio Tinto",
        long_name: "Rio Tinto",
        country: "Portugal",
        latitud: 41.1967006,
        longitud: -8.6462797,
        northeast: "41.2782,-8.5694",
        southwest: "41.1709,-8.7352",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Dijon",
        long_name: "Dijon",
        country: "France",
        latitud: 47.3263823,
        longitud: 5.0423706,
        northeast: "47.3571,5.0725",
        southwest: "47.2852,4.9902",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        // Las tres zonas de Malta salieron de partir una sola que se llamaba
        // "Triq Il-Merill" (el nombre de una calle) y abarcaba 10 x 16 km, o sea
        // media isla: mezclaba Mellieħa con Sliema, que están a 14 km. Cada caja
        // cubre el pueblo y contiene los alojamientos que ya existen, con margen.
        comuna: "Mellieħa",
        long_name: "Mellieħa",
        country: "Malta",
        latitud: 35.9575,
        longitud: 14.3625,
        northeast: "35.9850,14.4050",
        southwest: "35.9350,14.3400",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "San Pawl il-Baħar",
        long_name: "San Pawl il-Baħar",
        country: "Malta",
        latitud: 35.9520,
        longitud: 14.4160,
        northeast: "35.9750,14.4450",
        southwest: "35.9300,14.4100",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        // Incluye Is-Swieqi, Tas-Sliema y Il-Kalkara, todos a menos de 5 km.
        comuna: "San Ġiljan",
        long_name: "San Ġiljan",
        country: "Malta",
        latitud: 35.9186,
        longitud: 14.4894,
        northeast: "35.9350,14.5450",
        southwest: "35.8800,14.4700",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Rouen",
        long_name: "Rouen",
        country: "France",
        latitud: 49.4316041,
        longitud: 1.0950231,
        northeast: "49.4587,1.1512",
        southwest: "49.3853,1.0439",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Clermont-Ferrand",
        long_name: "Clermont-Ferrand",
        country: "France",
        latitud: 45.7804203,
        longitud: 3.0911248,
        northeast: "45.8033,3.1242",
        southwest: "45.7574,3.0570",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Peniche",
        long_name: "Peniche",
        country: "Portugal",
        latitud: 39.3750687,
        longitud: -9.2538224,
        northeast: "39.5193,-9.0596",
        southwest: "39.3182,-9.3941",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Campobasso",
        long_name: "Campobasso",
        country: "Italy",
        latitud: 41.5571203,
        longitud: 14.6624825,
        northeast: "41.5703,14.6795",
        southwest: "41.5366,14.6519",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Alicante (alrededores)",
        long_name: "Alicante (alrededores)",
        country: "España",
        latitud: 38.2654597,
        longitud: -0.7062869,
        northeast: "38.2801,-0.6907",
        southwest: "38.2510,-0.7202",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Amiens",
        long_name: "Amiens",
        country: "France",
        latitud: 49.8905147,
        longitud: 2.3072332,
        northeast: "49.9181,2.3362",
        southwest: "49.8720,2.2716",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Termoli",
        long_name: "Termoli",
        country: "Italy",
        latitud: 42.01015,
        longitud: 14.95372,
        northeast: "42.0202,14.9637",
        southwest: "42.0002,14.9437",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lido di Ostia",
        long_name: "Lido di Ostia",
        country: "Italy",
        latitud: 41.7551896,
        longitud: 12.2783571,
        northeast: "41.8472,12.3695",
        southwest: "41.7157,12.1998",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ferrara",
        long_name: "Ferrara",
        country: "Italy",
        latitud: 44.8306036,
        longitud: 11.6272957,
        northeast: "44.8517,11.7269",
        southwest: "44.7913,11.5899",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cádiz",
        long_name: "Cádiz",
        country: "España",
        latitud: 36.6860104,
        longitud: -6.1303295,
        northeast: "36.7033,-6.1086",
        southwest: "36.6645,-6.1556",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Mannheim",
        long_name: "Mannheim",
        country: "Germany",
        latitud: 49.4725708,
        longitud: 8.5038864,
        northeast: "49.5166,8.6967",
        southwest: "49.3812,8.4495",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Fontainebleau",
        long_name: "Fontainebleau",
        country: "France",
        latitud: 48.40667,
        longitud: 2.6982022,
        northeast: "48.4193,2.7110",
        southwest: "48.3930,2.6842",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Valenciennes",
        long_name: "Valenciennes",
        country: "France",
        latitud: 50.3581387,
        longitud: 3.5181891,
        northeast: "50.3762,3.5363",
        southwest: "50.3432,3.4993",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Marina di Caronia",
        long_name: "Marina di Caronia",
        country: "Italy",
        latitud: 38.0227191,
        longitud: 14.3953896,
        northeast: "38.0470,14.4694",
        southwest: "37.9980,14.3016",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Almería",
        long_name: "Almería",
        country: "España",
        latitud: 36.8387995,
        longitud: -2.4598762,
        northeast: "36.8524,-2.4384",
        southwest: "36.8181,-2.4746",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Vallevò",
        long_name: "Vallevò",
        country: "Italy",
        latitud: 42.0805719,
        longitud: 14.7496895,
        northeast: "42.0907,14.7599",
        southwest: "42.0678,14.7397",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Montpellier",
        long_name: "Montpellier",
        country: "France",
        latitud: 43.608249,
        longitud: 3.8673734,
        northeast: "43.6347,3.8984",
        southwest: "43.5751,3.8343",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Monopoli",
        long_name: "Monopoli",
        country: "Italy",
        latitud: 40.9466805,
        longitud: 17.2982295,
        northeast: "41.0056,17.3562",
        southwest: "40.8964,17.2136",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cergy",
        long_name: "Cergy",
        country: "France",
        latitud: 49.0397167,
        longitud: 2.0724697,
        northeast: "49.0612,2.1159",
        southwest: "49.0189,2.0181",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Aveiro",
        long_name: "Aveiro",
        country: "Portugal",
        latitud: 40.6425676,
        longitud: -8.6530276,
        northeast: "40.6555,-8.6367",
        southwest: "40.6151,-8.6656",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Zürich",
        long_name: "Zürich",
        country: "Switzerland",
        latitud: 47.381821,
        longitud: 8.5220708,
        northeast: "47.4504,8.5666",
        southwest: "47.3366,8.3500",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Angers",
        long_name: "Angers",
        country: "France",
        latitud: 47.4694675,
        longitud: -0.5445104,
        northeast: "47.4950,-0.5093",
        southwest: "47.4356,-0.5737",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Reggio Emilia",
        long_name: "Reggio Emilia",
        country: "Italy",
        latitud: 44.6990275,
        longitud: 10.628611,
        northeast: "44.7216,10.6454",
        southwest: "44.6575,10.5197",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lorient",
        long_name: "Lorient",
        country: "France",
        latitud: 47.75414,
        longitud: -3.3709156,
        northeast: "47.7759,-3.3478",
        southwest: "47.7354,-3.3998",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bergamo",
        long_name: "Bergamo",
        country: "Italy",
        latitud: 45.6773561,
        longitud: 9.6570201,
        northeast: "45.7318,9.7253",
        southwest: "45.6269,9.5890",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Toulon",
        long_name: "Toulon",
        country: "France",
        latitud: 43.1232565,
        longitud: 5.9084651,
        northeast: "43.1418,5.9579",
        southwest: "43.1009,5.8377",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Metz",
        long_name: "Metz",
        country: "France",
        latitud: 49.1092153,
        longitud: 6.1694342,
        northeast: "49.1355,6.1900",
        southwest: "49.0868,6.1430",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Locarno",
        long_name: "Locarno",
        country: "Switzerland",
        latitud: 46.1739847,
        longitud: 8.8005252,
        northeast: "46.2682,8.8628",
        southwest: "46.1504,8.7540",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sanremo",
        long_name: "Sanremo",
        country: "Italy",
        latitud: 43.8159544,
        longitud: 7.7670445,
        northeast: "43.8342,7.8046",
        southwest: "43.7830,7.6497",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "São João da Madeira",
        long_name: "São João da Madeira",
        country: "Portugal",
        latitud: 40.89938,
        longitud: -8.492296,
        northeast: "40.9094,-8.4823",
        southwest: "40.8894,-8.5023",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Udine",
        long_name: "Udine",
        country: "Italy",
        latitud: 46.0686231,
        longitud: 13.2328894,
        northeast: "46.0952,13.2540",
        southwest: "46.0470,13.2051",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pavia",
        long_name: "Pavia",
        country: "Italy",
        latitud: 45.1804338,
        longitud: 9.1540726,
        northeast: "45.2033,9.1802",
        southwest: "45.1493,9.1277",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Kassel",
        long_name: "Kassel",
        country: "Germany",
        latitud: 51.31639,
        longitud: 9.497522,
        northeast: "51.3264,9.5075",
        southwest: "51.3064,9.4875",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Rimini",
        long_name: "Rimini",
        country: "Italy",
        latitud: 44.0146027,
        longitud: 12.6517093,
        northeast: "44.0821,12.7547",
        southwest: "43.9544,12.5539",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Coventry",
        long_name: "Coventry",
        country: "United-Kingdom",
        latitud: 52.396612,
        longitud: -1.532262,
        northeast: "52.4141,-1.5032",
        southwest: "52.3781,-1.5640",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pau",
        long_name: "Pau",
        country: "France",
        latitud: 43.3033567,
        longitud: -0.3665386,
        northeast: "43.3201,-0.3470",
        southwest: "43.2887,-0.3841",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Anzola dell'Emilia",
        long_name: "Anzola dell'Emilia",
        country: "Italy",
        latitud: 44.55606,
        longitud: 11.1852214,
        northeast: "44.6499,11.2540",
        southwest: "44.4741,11.1609",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Alba",
        long_name: "Alba",
        country: "Italy",
        latitud: 44.7132679,
        longitud: 8.0281403,
        northeast: "44.8451,8.1030",
        southwest: "44.6280,7.9213",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Dresden",
        long_name: "Dresden",
        country: "Germany",
        latitud: 51.0530229,
        longitud: 13.7425229,
        northeast: "51.0948,13.7990",
        southwest: "51.0200,13.7112",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Avignon",
        long_name: "Avignon",
        country: "France",
        latitud: 43.9402221,
        longitud: 4.8132739,
        northeast: "43.9619,4.8394",
        southwest: "43.9146,4.7953",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Aix-en-Provence",
        long_name: "Aix-en-Provence",
        country: "France",
        latitud: 43.5233385,
        longitud: 5.4378317,
        northeast: "43.5397,5.4968",
        southwest: "43.5022,5.4024",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Troyes",
        long_name: "Troyes",
        country: "France",
        latitud: 48.2978085,
        longitud: 4.0776301,
        northeast: "48.3163,4.1027",
        southwest: "48.2796,4.0538",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Barcelona (alrededores)",
        long_name: "Barcelona (alrededores)",
        country: "España",
        latitud: 41.5437823,
        longitud: 2.1024997,
        northeast: "41.5645,2.1220",
        southwest: "41.5271,2.0773",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Manfredonia",
        long_name: "Manfredonia",
        country: "Italy",
        latitud: 41.6695033,
        longitud: 15.93834,
        northeast: "41.7171,15.9726",
        southwest: "41.6181,15.9017",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Claro",
        long_name: "Claro",
        country: "Switzerland",
        latitud: 46.24352,
        longitud: 9.031857,
        northeast: "46.2535,9.0419",
        southwest: "46.2335,9.0219",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Nürnberg",
        long_name: "Nürnberg",
        country: "Germany",
        latitud: 49.4486682,
        longitud: 11.0714273,
        northeast: "49.4767,11.1078",
        southwest: "49.4187,11.0308",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Mainz",
        long_name: "Mainz",
        country: "Germany",
        latitud: 49.9876618,
        longitud: 8.3457015,
        northeast: "50.0948,8.5797",
        southwest: "49.9036,8.1499",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Saint-Nazaire",
        long_name: "Saint-Nazaire",
        country: "France",
        latitud: 47.277467,
        longitud: -2.2109417,
        northeast: "47.2898,-2.1978",
        southwest: "47.2639,-2.2266",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Málaga (alrededores) 2",
        long_name: "Málaga (alrededores) 2",
        country: "España",
        latitud: 36.662696,
        longitud: -4.7558648,
        northeast: "36.6735,-4.7387",
        southwest: "36.6525,-4.7677",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Leicester",
        long_name: "Leicester",
        country: "United-Kingdom",
        latitud: 52.626672,
        longitud: -1.1538822,
        northeast: "52.6429,-1.1427",
        southwest: "52.6125,-1.1647",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Leeds",
        long_name: "Leeds",
        country: "United-Kingdom",
        latitud: 53.804035,
        longitud: -1.5552676,
        northeast: "53.8199,-1.5146",
        southwest: "53.7809,-1.6169",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Oslo",
        long_name: "Oslo",
        country: "Norway",
        latitud: 59.920628,
        longitud: 10.76133,
        northeast: "59.9361,10.7857",
        southwest: "59.9039,10.7422",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Osco",
        long_name: "Osco",
        country: "Switzerland",
        latitud: 46.467689,
        longitud: 8.8035845,
        northeast: "46.5041,8.9020",
        southwest: "46.3959,8.7529",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Asiago",
        long_name: "Asiago",
        country: "Italy",
        latitud: 45.878109,
        longitud: 11.499851,
        northeast: "45.9021,11.5632",
        southwest: "45.8592,11.4495",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Vicenza",
        long_name: "Vicenza",
        country: "Italy",
        latitud: 45.54446,
        longitud: 11.53532,
        northeast: "45.5545,11.5453",
        southwest: "45.5345,11.5253",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Poitiers",
        long_name: "Poitiers",
        country: "France",
        latitud: 46.585368,
        longitud: 0.3426695,
        northeast: "46.6007,0.3683",
        southwest: "46.5602,0.3132",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lecce",
        long_name: "Lecce",
        country: "Italy",
        latitud: 40.3709611,
        longitud: 18.23857,
        northeast: "40.3993,18.3137",
        southwest: "40.3392,18.1599",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Santa Marta de Portuzelo",
        long_name: "Santa Marta de Portuzelo",
        country: "Portugal",
        latitud: 41.7083244,
        longitud: -8.7769341,
        northeast: "41.7202,-8.7605",
        southwest: "41.6831,-8.8381",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Alicante (alrededores) 2",
        long_name: "Alicante (alrededores) 2",
        country: "España",
        latitud: 38.53454,
        longitud: -0.1063372,
        northeast: "38.5445,-0.0963",
        southwest: "38.5245,-0.1163",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Angoulême",
        long_name: "Angoulême",
        country: "France",
        latitud: 45.6466322,
        longitud: 0.1613142,
        northeast: "45.6617,0.1773",
        southwest: "45.6326,0.1425",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Böblingen",
        long_name: "Böblingen",
        country: "Germany",
        latitud: 48.6873588,
        longitud: 9.0042419,
        northeast: "48.6981,9.0278",
        southwest: "48.6721,8.9923",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Darmstadt",
        long_name: "Darmstadt",
        country: "Germany",
        latitud: 49.86811,
        longitud: 8.6291425,
        northeast: "49.8781,8.6391",
        southwest: "49.8581,8.6191",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Badajoz",
        long_name: "Badajoz",
        // El feed traía el país mal: estas coordenadas son España, no Portugal.
        country: "España",
        latitud: 38.8612,
        longitud: -6.94043,
        northeast: "38.8712,-6.9304",
        southwest: "38.8512,-6.9504",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Antibes",
        long_name: "Antibes",
        country: "France",
        latitud: 43.5767713,
        longitud: 7.0573606,
        northeast: "43.6135,7.1310",
        southwest: "43.5125,6.9187",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Maidstone",
        long_name: "Maidstone",
        country: "United-Kingdom",
        latitud: 51.27512,
        longitud: 0.5310236,
        northeast: "51.2851,0.5410",
        southwest: "51.2651,0.5210",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Manchester",
        long_name: "Manchester",
        country: "United-Kingdom",
        latitud: 53.4768975,
        longitud: -2.24133,
        northeast: "53.4950,-2.2298",
        southwest: "53.4425,-2.2560",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Le Havre",
        long_name: "Le Havre",
        country: "France",
        latitud: 49.4984738,
        longitud: 0.1334398,
        northeast: "49.5102,0.1511",
        southwest: "49.4866,0.1167",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Vale de Bouro",
        long_name: "Vale de Bouro",
        country: "Portugal",
        latitud: 41.4285075,
        longitud: -8.0000105,
        northeast: "41.4562,-7.9744",
        southwest: "41.3548,-8.0623",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Mértola",
        long_name: "Mértola",
        country: "Portugal",
        latitud: 37.7210088,
        longitud: -7.7073949,
        northeast: "37.7311,-7.6971",
        southwest: "37.7108,-7.7176",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pompei",
        long_name: "Pompei",
        country: "Italy",
        latitud: 40.74788,
        longitud: 14.500125,
        northeast: "40.7581,14.5107",
        southwest: "40.7376,14.4896",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Camaiore",
        long_name: "Camaiore",
        country: "Italy",
        latitud: 43.8861337,
        longitud: 10.23824,
        northeast: "43.9108,10.2611",
        southwest: "43.8568,10.2169",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Espinho",
        long_name: "Espinho",
        country: "Portugal",
        latitud: 41.0142513,
        longitud: -8.6404416,
        northeast: "41.0581,-8.6245",
        southwest: "40.9917,-8.6630",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pescate",
        long_name: "Pescate",
        country: "Italy",
        latitud: 45.8460763,
        longitud: 9.3868249,
        northeast: "45.9105,9.4055",
        southwest: "45.8200,9.3266",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Málaga (alrededores) 3",
        long_name: "Málaga (alrededores) 3",
        country: "España",
        latitud: 36.4619425,
        longitud: -5.0836311,
        northeast: "36.4791,-5.0621",
        southwest: "36.4118,-5.1595",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Wolfsburg",
        long_name: "Wolfsburg",
        country: "Germany",
        latitud: 52.4408429,
        longitud: 10.836,
        northeast: "52.4509,10.8464",
        southwest: "52.4308,10.8258",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Alghero",
        long_name: "Alghero",
        country: "Italy",
        latitud: 40.5657914,
        longitud: 8.3194336,
        northeast: "40.5852,8.3320",
        southwest: "40.5440,8.3038",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Medicina",
        long_name: "Medicina",
        country: "Italy",
        latitud: 44.4664814,
        longitud: 11.5965757,
        northeast: "44.4881,11.6482",
        southwest: "44.4353,11.4647",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Málaga (alrededores) 4",
        long_name: "Málaga (alrededores) 4",
        country: "España",
        latitud: 36.5090986,
        longitud: -4.9060044,
        northeast: "36.5196,-4.8836",
        southwest: "36.4969,-4.9631",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Biella",
        long_name: "Biella",
        country: "Italy",
        latitud: 45.5781786,
        longitud: 8.0603204,
        northeast: "45.6142,8.0756",
        southwest: "45.5530,8.0414",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "York",
        long_name: "York",
        country: "United-Kingdom",
        latitud: 53.9551667,
        longitud: -1.0703867,
        northeast: "53.9652,-1.0604",
        southwest: "53.9452,-1.0804",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Carcassonne",
        long_name: "Carcassonne",
        country: "France",
        latitud: 43.2173733,
        longitud: 2.355623,
        northeast: "43.2385,2.3704",
        southwest: "43.2018,2.3433",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Stresa",
        long_name: "Stresa",
        country: "Italy",
        latitud: 45.9064167,
        longitud: 8.6039577,
        northeast: "45.9775,8.7213",
        southwest: "45.8650,8.4942",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Siena",
        long_name: "Siena",
        country: "Italy",
        latitud: 43.3371367,
        longitud: 11.2990933,
        northeast: "43.3556,11.3431",
        southwest: "43.3013,11.2621",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Rozzano",
        long_name: "Rozzano",
        country: "Italy",
        latitud: 45.3647417,
        longitud: 9.1546317,
        northeast: "45.3950,9.1846",
        southwest: "45.3191,9.0911",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bari",
        long_name: "Bari",
        country: "Italy",
        latitud: 41.0972733,
        longitud: 16.869755,
        northeast: "41.1321,16.8869",
        southwest: "41.0677,16.8553",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lu Bagnu",
        long_name: "Lu Bagnu",
        country: "Italy",
        latitud: 40.9159167,
        longitud: 8.7602712,
        northeast: "40.9559,8.9037",
        southwest: "40.8916,8.6763",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Catania",
        long_name: "Catania",
        country: "Italy",
        latitud: 37.5151567,
        longitud: 15.0750717,
        northeast: "37.5447,15.1056",
        southwest: "37.4877,14.9781",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bad Nauheim",
        long_name: "Bad Nauheim",
        country: "Germany",
        latitud: 50.36338,
        longitud: 8.752739,
        northeast: "50.3734,8.7627",
        southwest: "50.3534,8.7427",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Certaldo",
        long_name: "Certaldo",
        country: "Italy",
        latitud: 43.5365,
        longitud: 11.05469,
        northeast: "43.5465,11.0647",
        southwest: "43.5265,11.0447",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Porto Torres",
        long_name: "Porto Torres",
        country: "Italy",
        latitud: 40.835495,
        longitud: 8.4069083,
        northeast: "40.8480,8.4203",
        southwest: "40.8213,8.3906",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Nice",
        long_name: "Nice",
        country: "France",
        latitud: 43.7033417,
        longitud: 7.2855798,
        northeast: "43.7406,7.3499",
        southwest: "43.6768,7.2070",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Mulhouse",
        long_name: "Mulhouse",
        country: "France",
        latitud: 47.7517133,
        longitud: 7.3204267,
        northeast: "47.7800,7.3473",
        southwest: "47.7345,7.2943",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Nîmes",
        long_name: "Nîmes",
        country: "France",
        latitud: 43.8382517,
        longitud: 4.354668,
        northeast: "43.8512,4.3871",
        southwest: "43.8269,4.3284",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Chambéry",
        long_name: "Chambéry",
        country: "France",
        latitud: 45.565655,
        longitud: 5.9200035,
        northeast: "45.5794,5.9401",
        southwest: "45.5477,5.8910",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Orléans",
        long_name: "Orléans",
        country: "France",
        latitud: 47.894205,
        longitud: 1.9237028,
        northeast: "47.9362,1.9460",
        southwest: "47.8283,1.8972",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Braunschweig",
        long_name: "Braunschweig",
        country: "Germany",
        latitud: 52.278362,
        longitud: 10.541838,
        northeast: "52.2909,10.5635",
        southwest: "52.2666,10.5012",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Nottingham",
        long_name: "Nottingham",
        country: "United-Kingdom",
        latitud: 52.94795,
        longitud: -1.145951,
        northeast: "52.9579,-1.1360",
        southwest: "52.9380,-1.1560",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Herentals",
        long_name: "Herentals",
        country: "Belgium",
        latitud: 51.13918,
        longitud: 4.819485,
        northeast: "51.1492,4.8295",
        southwest: "51.1292,4.8095",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Vallendar",
        long_name: "Vallendar",
        country: "Germany",
        latitud: 50.38809,
        longitud: 7.5898558,
        northeast: "50.4102,7.6267",
        southwest: "50.3598,7.5211",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Rocca San Giovanni",
        long_name: "Rocca San Giovanni",
        country: "Italy",
        latitud: 42.241256,
        longitud: 14.439314,
        northeast: "42.2616,14.4759",
        southwest: "42.2158,14.3824",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Madrid (alrededores) 3",
        long_name: "Madrid (alrededores) 3",
        country: "España",
        latitud: 40.35334,
        longitud: -3.5206512,
        northeast: "40.3643,-3.5103",
        southwest: "40.3420,-3.5311",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Las Palmas",
        long_name: "Las Palmas",
        country: "España",
        latitud: 28.113664,
        longitud: -15.423824,
        northeast: "28.1485,-15.4047",
        southwest: "28.0862,-15.4445",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "La Spezia",
        long_name: "La Spezia",
        country: "Italy",
        latitud: 44.106556,
        longitud: 9.8028728,
        northeast: "44.1183,9.8369",
        southwest: "44.0906,9.7265",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Mortara",
        long_name: "Mortara",
        country: "Italy",
        latitud: 45.25183,
        longitud: 8.733934,
        northeast: "45.2618,8.7439",
        southwest: "45.2418,8.7239",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Baden-Baden",
        long_name: "Baden-Baden",
        country: "Germany",
        latitud: 48.769866,
        longitud: 8.2248518,
        northeast: "48.7801,8.2424",
        southwest: "48.7591,8.2130",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bielefeld",
        long_name: "Bielefeld",
        country: "Germany",
        latitud: 52.035362,
        longitud: 8.5071738,
        northeast: "52.0649,8.5391",
        southwest: "52.0033,8.4347",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Messina",
        long_name: "Messina",
        country: "Italy",
        latitud: 38.26365,
        longitud: 15.63103,
        northeast: "38.2736,15.6410",
        southwest: "38.2537,15.6210",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Melun",
        long_name: "Melun",
        country: "France",
        latitud: 48.53531,
        longitud: 2.6585842,
        northeast: "48.5511,2.6698",
        southwest: "48.5189,2.6471",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Alessandria",
        long_name: "Alessandria",
        country: "Italy",
        latitud: 44.904458,
        longitud: 8.6241156,
        northeast: "44.9145,8.6357",
        southwest: "44.8944,8.6117",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Hemmingen-Westerfeld",
        long_name: "Hemmingen-Westerfeld",
        country: "Germany",
        latitud: 52.317742,
        longitud: 9.7426042,
        northeast: "52.3392,9.8294",
        southwest: "52.2901,9.7101",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Illes Balears",
        long_name: "Illes Balears",
        country: "España",
        latitud: 38.909404,
        longitud: 1.4350734,
        northeast: "38.9194,1.4451",
        southwest: "38.8994,1.4251",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Magdeburg",
        long_name: "Magdeburg",
        country: "Germany",
        latitud: 52.123525,
        longitud: 11.620775,
        northeast: "52.1422,11.6421",
        southwest: "52.0982,11.5931",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "A Coruña",
        long_name: "A Coruña",
        country: "España",
        latitud: 42.77161,
        longitud: -8.898861,
        northeast: "42.7816,-8.8889",
        southwest: "42.7616,-8.9089",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Liverpool",
        long_name: "Liverpool",
        country: "United-Kingdom",
        latitud: 53.40851,
        longitud: -2.985116,
        northeast: "53.4185,-2.9751",
        southwest: "53.3985,-2.9951",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sheffield",
        long_name: "Sheffield",
        country: "United-Kingdom",
        latitud: 53.37807,
        longitud: -1.474004,
        northeast: "53.3881,-1.4640",
        southwest: "53.3681,-1.4840",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Saint-Quentin",
        long_name: "Saint-Quentin",
        country: "France",
        latitud: 49.8475875,
        longitud: 3.2894318,
        northeast: "49.8658,3.2998",
        southwest: "49.8348,3.2783",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Luxemburgo",
        long_name: "Luxemburgo",
        // El feed traía el país mal: las direcciones dicen 1520 y 2543 Luxembourg.
        country: "Luxembourg",
        latitud: 49.59758,
        longitud: 6.1335002,
        northeast: "49.6141,6.1464",
        southwest: "49.5854,6.1147",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Middelkerke",
        long_name: "Middelkerke",
        country: "Belgium",
        latitud: 51.16684,
        longitud: 2.769037,
        northeast: "51.1768,2.7790",
        southwest: "51.1568,2.7590",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Alcamo",
        long_name: "Alcamo",
        country: "Italy",
        latitud: 38.0235775,
        longitud: 12.91048,
        northeast: "38.0732,12.9743",
        southwest: "37.9702,12.8150",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Herzogenaurach",
        long_name: "Herzogenaurach",
        country: "Germany",
        latitud: 49.566845,
        longitud: 10.88211,
        northeast: "49.5799,10.8927",
        southwest: "49.5538,10.8715",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Annecy",
        long_name: "Annecy",
        country: "France",
        latitud: 45.8924975,
        longitud: 6.1100545,
        northeast: "45.9080,6.1260",
        southwest: "45.8807,6.0981",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Offenbach am Main",
        long_name: "Offenbach am Main",
        country: "Germany",
        latitud: 50.11571,
        longitud: 8.80923,
        northeast: "50.1257,8.8192",
        southwest: "50.1057,8.7992",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Woking",
        long_name: "Woking",
        country: "United-Kingdom",
        latitud: 51.3156725,
        longitud: -0.5590436,
        northeast: "51.3269,-0.5487",
        southwest: "51.3019,-0.5701",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Póvoa de Varzim",
        long_name: "Póvoa de Varzim",
        country: "Portugal",
        latitud: 41.421135,
        longitud: -8.77595,
        northeast: "41.4450,-8.7519",
        southwest: "41.3839,-8.7927",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sesimbra",
        long_name: "Sesimbra",
        country: "Portugal",
        latitud: 38.451835,
        longitud: -9.116903,
        northeast: "38.4834,-9.0859",
        southwest: "38.4323,-9.1811",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pesaro",
        long_name: "Pesaro",
        country: "Italy",
        latitud: 43.908725,
        longitud: 12.91373,
        northeast: "43.9239,12.9252",
        southwest: "43.8967,12.9028",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Setúbal",
        long_name: "Setúbal",
        country: "Portugal",
        latitud: 38.52542,
        longitud: -8.9085063,
        northeast: "38.5620,-8.8777",
        southwest: "38.4943,-8.9622",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Vila do Bpo.",
        long_name: "Vila do Bpo.",
        country: "Portugal",
        latitud: 37.137515,
        longitud: -8.8833408,
        northeast: "37.1951,-8.8523",
        southwest: "37.0727,-8.9209",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Poznań",
        long_name: "Poznań",
        country: "Poland",
        latitud: 52.40395,
        longitud: 16.93065,
        northeast: "52.4139,16.9407",
        southwest: "52.3940,16.9206",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ovar",
        long_name: "Ovar",
        country: "Portugal",
        latitud: 40.8726825,
        longitud: -8.6667002,
        northeast: "40.8841,-8.6547",
        southwest: "40.8613,-8.6821",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Fiorano Modenese",
        long_name: "Fiorano Modenese",
        country: "Italy",
        latitud: 44.5373975,
        longitud: 10.82378,
        northeast: "44.5596,10.8430",
        southwest: "44.5233,10.7862",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "San Giorgio di Piano",
        long_name: "San Giorgio di Piano",
        country: "Italy",
        latitud: 44.647545,
        longitud: 11.3917875,
        northeast: "44.6683,11.4301",
        southwest: "44.6277,11.3634",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ludwigsburg",
        long_name: "Ludwigsburg",
        country: "Germany",
        latitud: 48.8986125,
        longitud: 9.2009435,
        northeast: "48.9111,9.2386",
        southwest: "48.8837,9.1792",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Stintino",
        long_name: "Stintino",
        country: "Italy",
        latitud: 40.94223,
        longitud: 8.215168,
        northeast: "40.9613,8.2304",
        southwest: "40.9051,8.1897",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Impruneta",
        long_name: "Impruneta",
        country: "Italy",
        latitud: 43.68649,
        longitud: 11.25535,
        northeast: "43.6965,11.2653",
        southwest: "43.6765,11.2454",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Germering",
        long_name: "Germering",
        country: "Germany",
        latitud: 48.1838825,
        longitud: 11.3766175,
        northeast: "48.2725,11.4479",
        southwest: "48.1210,11.3454",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Illes Balears 2",
        long_name: "Illes Balears 2",
        country: "España",
        latitud: 38.881235,
        longitud: 1.2911325,
        northeast: "38.8923,1.3016",
        southwest: "38.8685,1.2809",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lindlar",
        long_name: "Lindlar",
        country: "Germany",
        latitud: 51.0176125,
        longitud: 7.381076,
        northeast: "51.0297,7.3916",
        southwest: "51.0069,7.3696",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Potsdam",
        long_name: "Potsdam",
        country: "Germany",
        latitud: 52.413975,
        longitud: 13.0182375,
        northeast: "52.4849,13.0296",
        southwest: "52.3836,13.0047",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Illes Balears 3",
        long_name: "Illes Balears 3",
        country: "España",
        latitud: 39.8894,
        longitud: 4.26309,
        northeast: "39.8994,4.2731",
        southwest: "39.8794,4.2531",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Roncade",
        long_name: "Roncade",
        country: "Italy",
        latitud: 45.61311,
        longitud: 12.3883075,
        northeast: "45.6410,12.4444",
        southwest: "45.5495,12.3629",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Augsburg-Lechhausen",
        long_name: "Augsburg-Lechhausen",
        country: "Germany",
        latitud: 48.3853475,
        longitud: 10.9112775,
        northeast: "48.3982,10.9447",
        southwest: "48.3669,10.8309",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Kaiserslautern",
        long_name: "Kaiserslautern",
        country: "Germany",
        latitud: 49.4426075,
        longitud: 7.7700048,
        northeast: "49.4595,7.7895",
        southwest: "49.4157,7.7347",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Granada (alrededores)",
        long_name: "Granada (alrededores)",
        country: "España",
        latitud: 37.14473,
        longitud: -3.60655,
        northeast: "37.1547,-3.5966",
        southwest: "37.1347,-3.6165",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Siracusa",
        long_name: "Siracusa",
        country: "Italy",
        latitud: 37.0667367,
        longitud: 15.28796,
        northeast: "37.0918,15.3051",
        southwest: "37.0477,15.2645",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bremen",
        long_name: "Bremen",
        country: "Germany",
        latitud: 53.0727333,
        longitud: 8.80228,
        northeast: "53.0915,8.8232",
        southwest: "53.0452,8.7704",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Exeter",
        long_name: "Exeter",
        country: "United-Kingdom",
        latitud: 50.72612,
        longitud: -3.527446,
        northeast: "50.7361,-3.5174",
        southwest: "50.7161,-3.5374",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Birmingham",
        long_name: "Birmingham",
        country: "United-Kingdom",
        latitud: 52.44836,
        longitud: -1.913393,
        northeast: "52.4584,-1.9034",
        southwest: "52.4384,-1.9234",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Le Mans",
        long_name: "Le Mans",
        country: "France",
        latitud: 48.00674,
        longitud: 0.1980488,
        northeast: "48.0167,0.2080",
        southwest: "47.9967,0.1880",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Chartres",
        long_name: "Chartres",
        country: "France",
        latitud: 48.4521167,
        longitud: 1.482667,
        northeast: "48.4761,1.5035",
        southwest: "48.4314,1.4648",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lommel",
        long_name: "Lommel",
        country: "Belgium",
        latitud: 51.2223,
        longitud: 5.314626,
        northeast: "51.2323,5.3246",
        southwest: "51.2123,5.3046",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Wrocław",
        long_name: "Wrocław",
        country: "Poland",
        latitud: 51.112,
        longitud: 16.9802,
        northeast: "51.1220,16.9902",
        southwest: "51.1020,16.9702",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bastogne",
        long_name: "Bastogne",
        country: "Belgium",
        latitud: 50.00303,
        longitud: 5.718123,
        northeast: "50.0130,5.7281",
        southwest: "49.9930,5.7081",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Évian-les-Bains",
        long_name: "Évian-les-Bains",
        country: "France",
        latitud: 46.3881267,
        longitud: 6.545636,
        northeast: "46.4045,6.5863",
        southwest: "46.3654,6.4743",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lourdes",
        long_name: "Lourdes",
        country: "France",
        latitud: 43.09158,
        longitud: -0.054207,
        northeast: "43.1016,-0.0442",
        southwest: "43.0816,-0.0642",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Civitavecchia",
        long_name: "Civitavecchia",
        country: "Italy",
        latitud: 42.0751167,
        longitud: 11.8118533,
        northeast: "42.1054,11.8659",
        southwest: "42.0246,11.7798",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Albacete",
        long_name: "Albacete",
        country: "España",
        latitud: 38.9940167,
        longitud: -1.8538457,
        northeast: "39.0043,-1.8405",
        southwest: "38.9835,-1.8655",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Toledo",
        long_name: "Toledo",
        country: "España",
        latitud: 39.86498,
        longitud: -3.9701193,
        northeast: "39.8768,-3.9432",
        southwest: "39.8514,-4.0139",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Esposende",
        long_name: "Esposende",
        country: "Portugal",
        latitud: 41.5460367,
        longitud: -8.7574403,
        northeast: "41.5684,-8.6947",
        southwest: "41.5255,-8.7982",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Nazaré",
        long_name: "Nazaré",
        country: "Portugal",
        latitud: 39.6043333,
        longitud: -9.070173,
        northeast: "39.6194,-9.0553",
        southwest: "39.5905,-9.0845",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Kraków",
        long_name: "Kraków",
        country: "Poland",
        latitud: 50.0587,
        longitud: 19.95393,
        northeast: "50.0687,19.9639",
        southwest: "50.0487,19.9439",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Valencia (alrededores) 2",
        long_name: "Valencia (alrededores) 2",
        country: "España",
        latitud: 39.28508,
        longitud: -0.2816199,
        northeast: "39.3177,-0.2511",
        southwest: "39.2434,-0.3065",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Viterbo",
        long_name: "Viterbo",
        country: "Italy",
        latitud: 42.41571,
        longitud: 12.1049767,
        northeast: "42.4271,12.1160",
        southwest: "42.4046,12.0937",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ameglia",
        long_name: "Ameglia",
        country: "Italy",
        latitud: 44.0368367,
        longitud: 10.0448743,
        northeast: "44.0798,10.1294",
        southwest: "43.9957,9.9544",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ladispoli",
        long_name: "Ladispoli",
        country: "Italy",
        latitud: 41.96567,
        longitud: 12.0876567,
        northeast: "42.0083,12.1079",
        southwest: "41.9357,12.0690",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lassan",
        long_name: "Lassan",
        country: "Germany",
        latitud: 53.9498,
        longitud: 13.8466,
        northeast: "53.9598,13.8566",
        southwest: "53.9398,13.8366",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Laubach",
        long_name: "Laubach",
        country: "Germany",
        latitud: 50.54864,
        longitud: 8.957003,
        northeast: "50.5586,8.9670",
        southwest: "50.5386,8.9470",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Marburg",
        long_name: "Marburg",
        country: "Germany",
        latitud: 50.79088,
        longitud: 8.764007,
        northeast: "50.8009,8.7740",
        southwest: "50.7809,8.7540",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sevilla (alrededores)",
        long_name: "Sevilla (alrededores)",
        country: "España",
        latitud: 37.4355,
        longitud: -6.04625,
        northeast: "37.4455,-6.0362",
        southwest: "37.4255,-6.0562",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Toledo 2",
        long_name: "Toledo 2",
        country: "España",
        latitud: 40.08989,
        longitud: -3.865727,
        northeast: "40.0999,-3.8557",
        southwest: "40.0799,-3.8757",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Rīga",
        long_name: "Rīga",
        country: "Latvia",
        latitud: 56.93501,
        longitud: 24.09888,
        northeast: "56.9450,24.1089",
        southwest: "56.9250,24.0889",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Vilnius",
        long_name: "Vilnius",
        country: "Lithuania",
        latitud: 54.75722,
        longitud: 25.27491,
        northeast: "54.7672,25.2849",
        southwest: "54.7472,25.2649",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Funchal",
        long_name: "Funchal",
        country: "Portugal",
        latitud: 32.6377167,
        longitud: -16.9432267,
        northeast: "32.6535,-16.9320",
        southwest: "32.6248,-16.9539",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bayreuth",
        long_name: "Bayreuth",
        country: "Germany",
        latitud: 49.94913,
        longitud: 11.56153,
        northeast: "49.9591,11.5715",
        southwest: "49.9391,11.5515",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Acquedolci",
        long_name: "Acquedolci",
        country: "Italy",
        latitud: 38.0463367,
        longitud: 14.6121567,
        northeast: "38.0656,14.6605",
        southwest: "38.0256,14.5677",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Caldelas",
        long_name: "Caldelas",
        country: "Portugal",
        latitud: 41.48476,
        longitud: -8.349018,
        northeast: "41.4948,-8.3390",
        southwest: "41.4748,-8.3590",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Vico Equense",
        long_name: "Vico Equense",
        country: "Italy",
        latitud: 40.6455967,
        longitud: 14.4014033,
        northeast: "40.6664,14.4282",
        southwest: "40.6140,14.3579",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Arena Po",
        long_name: "Arena Po",
        country: "Italy",
        latitud: 45.0866967,
        longitud: 9.3291837,
        northeast: "45.1070,9.3711",
        southwest: "45.0561,9.2554",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Perarolo di Cadore",
        long_name: "Perarolo di Cadore",
        country: "Italy",
        latitud: 46.4081667,
        longitud: 12.31732,
        northeast: "46.4404,12.3655",
        southwest: "46.3871,12.2310",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Alice Castello",
        long_name: "Alice Castello",
        country: "Italy",
        latitud: 45.3890733,
        longitud: 8.062487,
        northeast: "45.4326,8.0810",
        southwest: "45.3620,8.0375",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cortona",
        long_name: "Cortona",
        country: "Italy",
        latitud: 43.27554,
        longitud: 11.9858067,
        northeast: "43.2856,11.9963",
        southwest: "43.2655,11.9755",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Vello",
        long_name: "Vello",
        country: "Italy",
        latitud: 45.75277,
        longitud: 10.08302,
        northeast: "45.7628,10.0930",
        southwest: "45.7428,10.0730",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Avola",
        long_name: "Avola",
        country: "Italy",
        latitud: 36.899455,
        longitud: 15.10439,
        northeast: "36.9195,15.1478",
        southwest: "36.8794,15.0610",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Trabia",
        long_name: "Trabia",
        country: "Italy",
        latitud: 37.994535,
        longitud: 13.65759,
        northeast: "38.0058,13.6680",
        southwest: "37.9833,13.6472",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Magny-le-Hongre",
        long_name: "Magny-le-Hongre",
        country: "France",
        latitud: 48.85511,
        longitud: 2.8159585,
        northeast: "48.8757,2.8275",
        southwest: "48.8345,2.8044",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Monti D'arena-bosco Caggione",
        long_name: "Monti D'arena-bosco Caggione",
        country: "Italy",
        latitud: 40.354605,
        longitud: 17.35839,
        northeast: "40.3646,17.3685",
        southwest: "40.3446,17.3483",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Wolverhampton",
        long_name: "Wolverhampton",
        country: "United-Kingdom",
        latitud: 52.578865,
        longitud: -2.074054,
        northeast: "52.5954,-2.0201",
        southwest: "52.5623,-2.1280",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Mol",
        long_name: "Mol",
        country: "Belgium",
        latitud: 51.18885,
        longitud: 5.117252,
        northeast: "51.1989,5.1273",
        southwest: "51.1789,5.1073",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "La Teste-de-Buch",
        long_name: "La Teste-de-Buch",
        country: "France",
        latitud: 44.61557,
        longitud: -1.115349,
        northeast: "44.6256,-1.1053",
        southwest: "44.6056,-1.1253",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Béziers",
        long_name: "Béziers",
        country: "France",
        latitud: 43.34486,
        longitud: 3.222117,
        northeast: "43.3549,3.2321",
        southwest: "43.3349,3.2121",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Divonne-les-Bains",
        long_name: "Divonne-les-Bains",
        country: "France",
        latitud: 46.36049,
        longitud: 6.134754,
        northeast: "46.3705,6.1448",
        southwest: "46.3505,6.1248",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Riccio",
        long_name: "Riccio",
        country: "Italy",
        latitud: 42.362255,
        longitud: 14.37975,
        northeast: "42.3768,14.4099",
        southwest: "42.3477,14.3496",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cava de' Tirreni",
        long_name: "Cava de' Tirreni",
        country: "Italy",
        latitud: 40.715005,
        longitud: 14.701745,
        northeast: "40.7363,14.7121",
        southwest: "40.6938,14.6914",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Münster",
        long_name: "Münster",
        country: "Germany",
        latitud: 51.939045,
        longitud: 7.6047365,
        northeast: "51.9534,7.6201",
        southwest: "51.9247,7.5893",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Murcia",
        long_name: "Murcia",
        country: "España",
        latitud: 37.98223,
        longitud: -1.1705385,
        northeast: "38.0017,-1.1167",
        southwest: "37.9627,-1.2243",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pias",
        long_name: "Pias",
        country: "Portugal",
        latitud: 38.11216,
        longitud: -7.59381,
        northeast: "38.1222,-7.5838",
        southwest: "38.1022,-7.6038",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Dannenfels",
        long_name: "Dannenfels",
        country: "Germany",
        latitud: 49.62588,
        longitud: 7.946072,
        northeast: "49.6359,7.9561",
        southwest: "49.6159,7.9361",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ravenna",
        long_name: "Ravenna",
        country: "Italy",
        latitud: 44.418225,
        longitud: 12.20263,
        northeast: "44.4284,12.2130",
        southwest: "44.4080,12.1923",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Dagnente",
        long_name: "Dagnente",
        country: "Italy",
        latitud: 45.76429,
        longitud: 8.550688,
        northeast: "45.7935,8.5773",
        southwest: "45.7351,8.5241",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ostuni",
        long_name: "Ostuni",
        country: "Italy",
        latitud: 40.72326,
        longitud: 17.43513,
        northeast: "40.7651,17.4849",
        southwest: "40.6815,17.3853",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sant'Anna Arresi",
        long_name: "Sant'Anna Arresi",
        country: "Italy",
        latitud: 38.982755,
        longitud: 8.6012,
        northeast: "39.0054,8.6212",
        southwest: "38.9601,8.5812",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Niscemi",
        long_name: "Niscemi",
        country: "Italy",
        latitud: 37.14656,
        longitud: 14.38505,
        northeast: "37.1566,14.3950",
        southwest: "37.1366,14.3750",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "León",
        long_name: "León",
        country: "España",
        latitud: 42.55118,
        longitud: -6.598698,
        northeast: "42.5612,-6.5887",
        southwest: "42.5412,-6.6087",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Jesi",
        long_name: "Jesi",
        country: "Italy",
        latitud: 43.525395,
        longitud: 13.24182,
        northeast: "43.5364,13.2568",
        southwest: "43.5144,13.2269",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lido di Jesolo",
        long_name: "Lido di Jesolo",
        country: "Italy",
        latitud: 45.507195,
        longitud: 12.6431,
        northeast: "45.5295,12.6881",
        southwest: "45.4849,12.5981",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Giardinetto-ponte Maggio",
        long_name: "Giardinetto-ponte Maggio",
        country: "Italy",
        latitud: 44.03966,
        longitud: 10.72207,
        northeast: "44.0524,10.7785",
        southwest: "44.0269,10.6656",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Monsanto",
        long_name: "Monsanto",
        country: "Portugal",
        latitud: 40.03929,
        longitud: -7.113925,
        northeast: "40.0493,-7.1029",
        southwest: "40.0292,-7.1250",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pontecorvo",
        long_name: "Pontecorvo",
        country: "Italy",
        latitud: 41.45757,
        longitud: 13.66625,
        northeast: "41.4676,13.6762",
        southwest: "41.4476,13.6563",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Policoro",
        long_name: "Policoro",
        country: "Italy",
        latitud: 40.21845,
        longitud: 16.69257,
        northeast: "40.2284,16.7026",
        southwest: "40.2084,16.6826",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Foligno",
        long_name: "Foligno",
        country: "Italy",
        latitud: 42.95147,
        longitud: 12.701645,
        northeast: "42.9669,12.7130",
        southwest: "42.9361,12.6903",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Arezzo",
        long_name: "Arezzo",
        country: "Italy",
        latitud: 43.465755,
        longitud: 11.876475,
        northeast: "43.4795,11.8874",
        southwest: "43.4520,11.8655",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Kirchheim unter Teck",
        long_name: "Kirchheim unter Teck",
        country: "Germany",
        latitud: 48.68287,
        longitud: 9.425352,
        northeast: "48.7203,9.4390",
        southwest: "48.6454,9.4117",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cervaro",
        long_name: "Cervaro",
        country: "Italy",
        latitud: 41.469,
        longitud: 13.88175,
        northeast: "41.4790,13.8918",
        southwest: "41.4590,13.8718",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Tanaunella",
        long_name: "Tanaunella",
        country: "Italy",
        latitud: 40.68357,
        longitud: 9.725696,
        northeast: "40.6936,9.7357",
        southwest: "40.6736,9.7157",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Foggia",
        long_name: "Foggia",
        country: "Italy",
        latitud: 41.45966,
        longitud: 15.543605,
        northeast: "41.4701,15.5603",
        southwest: "41.4492,15.5269",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Salò",
        long_name: "Salò",
        country: "Italy",
        latitud: 45.568905,
        longitud: 10.51284,
        northeast: "45.6211,10.5245",
        southwest: "45.5167,10.5012",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Osnabrück",
        long_name: "Osnabrück",
        country: "Germany",
        latitud: 52.28082,
        longitud: 8.043898,
        northeast: "52.2908,8.0539",
        southwest: "52.2708,8.0339",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sapri",
        long_name: "Sapri",
        country: "Italy",
        latitud: 40.07315,
        longitud: 15.63068,
        northeast: "40.0831,15.6407",
        southwest: "40.0632,15.6207",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Anzio",
        long_name: "Anzio",
        country: "Italy",
        latitud: 41.45071,
        longitud: 12.627925,
        northeast: "41.4617,12.6455",
        southwest: "41.4397,12.6104",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Innsbruck",
        long_name: "Innsbruck",
        country: "Austria",
        latitud: 47.264655,
        longitud: 11.392625,
        northeast: "47.2785,11.4059",
        southwest: "47.2508,11.3794",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sarroch",
        long_name: "Sarroch",
        country: "Italy",
        latitud: 39.042835,
        longitud: 9.007491,
        northeast: "39.0803,9.0198",
        southwest: "39.0053,8.9952",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Gerbrunn",
        long_name: "Gerbrunn",
        country: "Germany",
        latitud: 49.785725,
        longitud: 9.976863,
        northeast: "49.8015,9.9903",
        southwest: "49.7700,9.9634",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cholet",
        long_name: "Cholet",
        country: "France",
        latitud: 47.06108,
        longitud: -0.8780334,
        northeast: "47.0711,-0.8680",
        southwest: "47.0511,-0.8880",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Blackpool",
        long_name: "Blackpool",
        country: "United-Kingdom",
        latitud: 53.814045,
        longitud: -3.0456065,
        northeast: "53.8355,-3.0264",
        southwest: "53.7925,-3.0648",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Battaglia Terme",
        long_name: "Battaglia Terme",
        country: "Italy",
        latitud: 45.28999,
        longitud: 11.78187,
        northeast: "45.3000,11.7919",
        southwest: "45.2800,11.7719",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Warszawa",
        long_name: "Warszawa",
        country: "Poland",
        latitud: 52.23754,
        longitud: 21.00299,
        northeast: "52.2475,21.0130",
        southwest: "52.2275,20.9930",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Eschweiler",
        long_name: "Eschweiler",
        country: "Germany",
        latitud: 50.81929,
        longitud: 6.283612,
        northeast: "50.8293,6.2936",
        southwest: "50.8093,6.2736",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Seclin",
        long_name: "Seclin",
        country: "France",
        latitud: 50.534195,
        longitud: 2.979104,
        northeast: "50.5499,3.0351",
        southwest: "50.5185,2.9231",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sevilla (alrededores) 2",
        long_name: "Sevilla (alrededores) 2",
        country: "España",
        latitud: 37.47198,
        longitud: -5.634274,
        northeast: "37.4820,-5.6243",
        southwest: "37.4620,-5.6443",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Senouillac",
        long_name: "Senouillac",
        country: "France",
        latitud: 43.96024,
        longitud: 1.942,
        northeast: "43.9702,1.9520",
        southwest: "43.9502,1.9320",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Oostende",
        long_name: "Oostende",
        country: "Belgium",
        latitud: 51.22889,
        longitud: 2.923243,
        northeast: "51.2389,2.9332",
        southwest: "51.2189,2.9132",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Marseille 2",
        long_name: "Marseille 2",
        country: "France",
        latitud: 43.31148,
        longitud: 6.382848,
        northeast: "43.3215,6.3928",
        southwest: "43.3015,6.3728",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Saint-Ghislain",
        long_name: "Saint-Ghislain",
        country: "Belgium",
        latitud: 50.44429,
        longitud: 3.821074,
        northeast: "50.4543,3.8311",
        southwest: "50.4343,3.8111",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Fréjus",
        long_name: "Fréjus",
        country: "France",
        latitud: 43.45502,
        longitud: 6.760907,
        northeast: "43.4650,6.7709",
        southwest: "43.4450,6.7509",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Narbonne",
        long_name: "Narbonne",
        country: "France",
        latitud: 43.1856,
        longitud: 3.009334,
        northeast: "43.1956,3.0193",
        southwest: "43.1756,2.9993",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Chiugiana",
        long_name: "Chiugiana",
        country: "Italy",
        latitud: 43.10322,
        longitud: 12.31706,
        northeast: "43.1132,12.3271",
        southwest: "43.0932,12.3071",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ancona",
        long_name: "Ancona",
        country: "Italy",
        latitud: 43.60723,
        longitud: 13.4998,
        northeast: "43.6172,13.5098",
        southwest: "43.5972,13.4898",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Torre del Greco",
        long_name: "Torre del Greco",
        country: "Italy",
        latitud: 40.78976,
        longitud: 14.37078,
        northeast: "40.7998,14.3808",
        southwest: "40.7798,14.3608",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Gagliano del Capo",
        long_name: "Gagliano del Capo",
        country: "Italy",
        latitud: 39.84442,
        longitud: 18.37478,
        northeast: "39.8544,18.3848",
        southwest: "39.8344,18.3648",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cosenza",
        long_name: "Cosenza",
        country: "Italy",
        latitud: 39.30256,
        longitud: 16.2516,
        northeast: "39.3126,16.2616",
        southwest: "39.2926,16.2416",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Gatteo a Mare",
        long_name: "Gatteo a Mare",
        country: "Italy",
        latitud: 44.17099,
        longitud: 12.43232,
        northeast: "44.1810,12.4423",
        southwest: "44.1610,12.4223",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pedrógão Grande",
        long_name: "Pedrógão Grande",
        country: "Portugal",
        // Centro en el pueblo y caja a escala del municipio. La original se armó
        // alrededor del único alojamiento del feed y medía 2 km: no llegaba al
        // centro, así que un alojamiento nuevo en el pueblo habría quedado fuera
        // de toda zona y por lo tanto invisible en la búsqueda.
        latitud: 39.9167,
        longitud: -8.1436,
        northeast: "39.9800,-8.1000",
        southwest: "39.8500,-8.2800",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Mercatello Sul Metauro",
        long_name: "Mercatello Sul Metauro",
        country: "Italy",
        latitud: 43.6482,
        longitud: 12.3366,
        northeast: "43.6582,12.3466",
        southwest: "43.6382,12.3266",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Mazara del Vallo",
        long_name: "Mazara del Vallo",
        country: "Italy",
        latitud: 37.65364,
        longitud: 12.59315,
        northeast: "37.6636,12.6031",
        southwest: "37.6436,12.5831",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Friedrichshafen",
        long_name: "Friedrichshafen",
        country: "Germany",
        latitud: 47.66589,
        longitud: 9.426416,
        northeast: "47.6759,9.4364",
        southwest: "47.6559,9.4164",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "L'Aquila",
        long_name: "L'Aquila",
        country: "Italy",
        latitud: 42.35227,
        longitud: 13.40832,
        northeast: "42.3623,13.4183",
        southwest: "42.3423,13.3983",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Wuppertal",
        long_name: "Wuppertal",
        country: "Germany",
        latitud: 51.25115,
        longitud: 7.136904,
        northeast: "51.2612,7.1469",
        southwest: "51.2412,7.1269",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Turrati-forche",
        long_name: "Turrati-forche",
        country: "Italy",
        latitud: 38.70045,
        longitud: 16.52601,
        northeast: "38.7104,16.5360",
        southwest: "38.6904,16.5160",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Seine-et-Marne",
        long_name: "Seine-et-Marne",
        country: "France",
        latitud: 48.84108,
        longitud: 2.999366,
        northeast: "48.8511,3.0094",
        southwest: "48.8311,2.9894",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Douai",
        long_name: "Douai",
        country: "France",
        latitud: 50.37963,
        longitud: 3.062964,
        northeast: "50.3896,3.0730",
        southwest: "50.3696,3.0530",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Narni Scalo",
        long_name: "Narni Scalo",
        country: "Italy",
        latitud: 42.55367,
        longitud: 12.50561,
        northeast: "42.5637,12.5156",
        southwest: "42.5437,12.4956",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sertã",
        long_name: "Sertã",
        country: "Portugal",
        latitud: 39.77308,
        longitud: -8.019772,
        northeast: "39.7831,-8.0098",
        southwest: "39.7631,-8.0298",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Albareto",
        long_name: "Albareto",
        country: "Italy",
        latitud: 44.44413,
        longitud: 9.697919,
        northeast: "44.4541,9.7079",
        southwest: "44.4341,9.6879",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Piscina",
        long_name: "Piscina",
        country: "Italy",
        latitud: 44.92113,
        longitud: 7.430159,
        northeast: "44.9311,7.4402",
        southwest: "44.9111,7.4202",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Leverkusen",
        long_name: "Leverkusen",
        country: "Germany",
        latitud: 51.06366,
        longitud: 7.01222,
        northeast: "51.0737,7.0222",
        southwest: "51.0537,7.0022",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Davos Platz",
        long_name: "Davos Platz",
        country: "Switzerland",
        latitud: 46.79902,
        longitud: 9.831002,
        northeast: "46.8090,9.8410",
        southwest: "46.7890,9.8210",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Silvaplana",
        long_name: "Silvaplana",
        country: "Switzerland",
        latitud: 46.46054,
        longitud: 9.795675,
        northeast: "46.4705,9.8057",
        southwest: "46.4505,9.7857",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cama",
        long_name: "Cama",
        country: "Switzerland",
        latitud: 46.27007,
        longitud: 9.168469,
        northeast: "46.2801,9.1785",
        southwest: "46.2601,9.1585",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "São Brás de Alportel",
        long_name: "São Brás de Alportel",
        country: "Portugal",
        latitud: 37.13283,
        longitud: -7.890518,
        northeast: "37.1428,-7.8805",
        southwest: "37.1228,-7.9005",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Piloni",
        long_name: "Piloni",
        country: "Italy",
        latitud: 42.42049,
        longitud: 12.53514,
        northeast: "42.4305,12.5451",
        southwest: "42.4105,12.5251",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Seui",
        long_name: "Seui",
        country: "Italy",
        latitud: 39.83943,
        longitud: 9.321569,
        northeast: "39.8494,9.3316",
        southwest: "39.8294,9.3116",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Voghera",
        long_name: "Voghera",
        country: "Italy",
        latitud: 44.99549,
        longitud: 9.008995,
        northeast: "45.0055,9.0190",
        southwest: "44.9855,8.9990",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Granaglione",
        long_name: "Granaglione",
        country: "Italy",
        latitud: 44.11482,
        longitud: 10.95689,
        northeast: "44.1248,10.9669",
        southwest: "44.1048,10.9469",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Aljezur",
        long_name: "Aljezur",
        country: "Portugal",
        latitud: 37.30794,
        longitud: -8.851424,
        northeast: "37.3179,-8.8414",
        southwest: "37.2979,-8.8614",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Dunkerque",
        long_name: "Dunkerque",
        country: "France",
        latitud: 51.0317,
        longitud: 2.3731,
        northeast: "51.0417,2.3831",
        southwest: "51.0217,2.3631",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Maratea",
        long_name: "Maratea",
        country: "Italy",
        latitud: 40.00024,
        longitud: 15.71911,
        northeast: "40.0102,15.7291",
        southwest: "39.9902,15.7091",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Penela",
        long_name: "Penela",
        country: "Portugal",
        latitud: 40.02937,
        longitud: -8.390216,
        northeast: "40.0394,-8.3802",
        southwest: "40.0194,-8.4002",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Civita Castellana",
        long_name: "Civita Castellana",
        country: "Italy",
        latitud: 42.28859,
        longitud: 12.41308,
        northeast: "42.2986,12.4231",
        southwest: "42.2786,12.4031",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Guarcino",
        long_name: "Guarcino",
        country: "Italy",
        latitud: 41.80066,
        longitud: 13.31594,
        northeast: "41.8107,13.3259",
        southwest: "41.7907,13.3059",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Endine Gaiano",
        long_name: "Endine Gaiano",
        country: "Italy",
        latitud: 45.79282,
        longitud: 9.958177,
        northeast: "45.8028,9.9682",
        southwest: "45.7828,9.9482",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Campi Bisenzio",
        long_name: "Campi Bisenzio",
        country: "Italy",
        latitud: 43.81485,
        longitud: 11.13926,
        northeast: "43.8248,11.1493",
        southwest: "43.8049,11.1293",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cortina d'Ampezzo",
        long_name: "Cortina d'Ampezzo",
        country: "Italy",
        latitud: 46.53866,
        longitud: 12.13417,
        northeast: "46.5487,12.1442",
        southwest: "46.5287,12.1242",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Trapani",
        long_name: "Trapani",
        country: "Italy",
        latitud: 38.01639,
        longitud: 12.51239,
        northeast: "38.0264,12.5224",
        southwest: "38.0064,12.5024",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Carpineto Romano",
        long_name: "Carpineto Romano",
        country: "Italy",
        latitud: 41.6053,
        longitud: 13.08641,
        northeast: "41.6153,13.0964",
        southwest: "41.5953,13.0764",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Palù",
        long_name: "Palù",
        country: "Italy",
        latitud: 46.22498,
        longitud: 10.82916,
        northeast: "46.2350,10.8392",
        southwest: "46.2150,10.8192",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sevilla (alrededores) 3",
        long_name: "Sevilla (alrededores) 3",
        country: "España",
        latitud: 37.44892,
        longitud: -5.932075,
        northeast: "37.4589,-5.9221",
        southwest: "37.4389,-5.9421",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sevilla (alrededores) 4",
        long_name: "Sevilla (alrededores) 4",
        country: "España",
        latitud: 37.38345,
        longitud: -6.157694,
        northeast: "37.3935,-6.1477",
        southwest: "37.3735,-6.1677",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sernancelhe",
        long_name: "Sernancelhe",
        country: "Portugal",
        // Ver el comentario de Pedrógão Grande: mismo caso.
        latitud: 40.8975,
        longitud: -7.4917,
        northeast: "40.9800,-7.4200",
        southwest: "40.8300,-7.6500",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Torvaianica",
        long_name: "Torvaianica",
        country: "Italy",
        latitud: 41.64014,
        longitud: 12.4406,
        northeast: "41.6501,12.4506",
        southwest: "41.6301,12.4306",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Malga Alta di Sotto",
        long_name: "Malga Alta di Sotto",
        country: "Italy",
        latitud: 45.88557,
        longitud: 10.09062,
        northeast: "45.8956,10.1006",
        southwest: "45.8756,10.0806",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Brindisi",
        long_name: "Brindisi",
        country: "Italy",
        latitud: 40.6355,
        longitud: 17.94139,
        northeast: "40.6455,17.9514",
        southwest: "40.6255,17.9314",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Eisenhüttenstadt",
        long_name: "Eisenhüttenstadt",
        country: "Germany",
        latitud: 52.14188,
        longitud: 14.61789,
        northeast: "52.1519,14.6279",
        southwest: "52.1319,14.6079",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Almacave",
        long_name: "Almacave",
        country: "Portugal",
        latitud: 41.10431,
        longitud: -7.808882,
        northeast: "41.1143,-7.7989",
        southwest: "41.0943,-7.8189",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Alqueva",
        long_name: "Alqueva",
        country: "Portugal",
        latitud: 38.21636,
        longitud: -7.53984,
        northeast: "38.2264,-7.5298",
        southwest: "38.2064,-7.5498",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Vila Nova de Cerveira",
        long_name: "Vila Nova de Cerveira",
        country: "Portugal",
        latitud: 41.91546,
        longitud: -8.77094,
        northeast: "41.9255,-8.7609",
        southwest: "41.9055,-8.7809",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Santa Cesarea Terme",
        long_name: "Santa Cesarea Terme",
        country: "Italy",
        latitud: 40.04041,
        longitud: 18.45754,
        northeast: "40.0504,18.4675",
        southwest: "40.0304,18.4475",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Marinha Grande",
        long_name: "Marinha Grande",
        country: "Portugal",
        latitud: 39.74114,
        longitud: -8.92977,
        northeast: "39.7511,-8.9198",
        southwest: "39.7311,-8.9398",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Almeida",
        long_name: "Almeida",
        country: "Portugal",
        latitud: 40.59373,
        longitud: -6.949266,
        northeast: "40.6037,-6.9393",
        southwest: "40.5837,-6.9593",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Monteverdi Marittimo",
        long_name: "Monteverdi Marittimo",
        country: "Italy",
        latitud: 43.17924,
        longitud: 10.71019,
        northeast: "43.1892,10.7202",
        southwest: "43.1692,10.7002",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ardea",
        long_name: "Ardea",
        country: "Italy",
        latitud: 41.5568,
        longitud: 12.53654,
        northeast: "41.5668,12.5465",
        southwest: "41.5468,12.5265",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ottobrunn-Riemerling",
        long_name: "Ottobrunn-Riemerling",
        country: "Germany",
        latitud: 48.05913,
        longitud: 11.6657,
        northeast: "48.0691,11.6757",
        southwest: "48.0491,11.6557",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Trecastagni",
        long_name: "Trecastagni",
        country: "Italy",
        latitud: 37.61794,
        longitud: 15.07878,
        northeast: "37.6279,15.0888",
        southwest: "37.6079,15.0688",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Todi",
        long_name: "Todi",
        country: "Italy",
        latitud: 42.73503,
        longitud: 12.36797,
        northeast: "42.7450,12.3780",
        southwest: "42.7250,12.3580",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Aÿ-Champagne",
        long_name: "Aÿ-Champagne",
        country: "France",
        latitud: 49.04576,
        longitud: 4.03693,
        northeast: "49.0558,4.0469",
        southwest: "49.0358,4.0269",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Minturno",
        long_name: "Minturno",
        country: "Italy",
        latitud: 41.26003,
        longitud: 13.71252,
        northeast: "41.2700,13.7225",
        southwest: "41.2500,13.7025",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "grosseto",
        long_name: "grosseto",
        country: "Italy",
        latitud: 42.72239,
        longitud: 10.98051,
        northeast: "42.7324,10.9905",
        southwest: "42.7124,10.9705",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Montalcino",
        long_name: "Montalcino",
        country: "Italy",
        latitud: 43.05598,
        longitud: 11.48632,
        northeast: "43.0660,11.4963",
        southwest: "43.0460,11.4763",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Villagrande",
        long_name: "Villagrande",
        country: "Italy",
        latitud: 43.84049,
        longitud: 12.36223,
        northeast: "43.8505,12.3722",
        southwest: "43.8305,12.3522",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Portoscuso",
        long_name: "Portoscuso",
        country: "Italy",
        latitud: 39.20726,
        longitud: 8.384312,
        northeast: "39.2173,8.3943",
        southwest: "39.1973,8.3743",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Palmadula",
        long_name: "Palmadula",
        country: "Italy",
        latitud: 40.74882,
        longitud: 8.190372,
        northeast: "40.7588,8.2004",
        southwest: "40.7388,8.1804",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "San Teodoro",
        long_name: "San Teodoro",
        country: "Italy",
        latitud: 40.77481,
        longitud: 9.659111,
        northeast: "40.7848,9.6691",
        southwest: "40.7648,9.6491",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Siniscola",
        long_name: "Siniscola",
        country: "Italy",
        latitud: 40.5693,
        longitud: 9.75805,
        northeast: "40.5793,9.7681",
        southwest: "40.5593,9.7481",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Porto Istana",
        long_name: "Porto Istana",
        country: "Italy",
        latitud: 40.89048,
        longitud: 9.611556,
        northeast: "40.9005,9.6216",
        southwest: "40.8805,9.6016",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Fosdinovo",
        long_name: "Fosdinovo",
        country: "Italy",
        latitud: 44.14253,
        longitud: 10.04366,
        northeast: "44.1525,10.0537",
        southwest: "44.1325,10.0337",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Castel del Piano",
        long_name: "Castel del Piano",
        country: "Italy",
        latitud: 42.89772,
        longitud: 11.52958,
        northeast: "42.9077,11.5396",
        southwest: "42.8877,11.5196",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Stockstadt am Main",
        long_name: "Stockstadt am Main",
        country: "Germany",
        latitud: 49.96596,
        longitud: 9.069316,
        northeast: "49.9760,9.0793",
        southwest: "49.9560,9.0593",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pavona",
        long_name: "Pavona",
        country: "Italy",
        latitud: 41.72651,
        longitud: 12.61652,
        northeast: "41.7365,12.6265",
        southwest: "41.7165,12.6065",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Fürstenwalde/Spree",
        long_name: "Fürstenwalde/Spree",
        country: "Germany",
        latitud: 52.36204,
        longitud: 14.06476,
        northeast: "52.3720,14.0748",
        southwest: "52.3520,14.0548",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bracciano",
        long_name: "Bracciano",
        country: "Italy",
        latitud: 42.10314,
        longitud: 12.17859,
        northeast: "42.1131,12.1886",
        southwest: "42.0931,12.1686",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Tegernsee",
        long_name: "Tegernsee",
        country: "Germany",
        latitud: 47.71519,
        longitud: 11.75485,
        northeast: "47.7252,11.7648",
        southwest: "47.7052,11.7448",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Chieri",
        long_name: "Chieri",
        country: "Italy",
        latitud: 45.01209,
        longitud: 7.825765,
        northeast: "45.0221,7.8358",
        southwest: "45.0021,7.8158",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Soave",
        long_name: "Soave",
        country: "Italy",
        latitud: 45.4239,
        longitud: 11.24783,
        northeast: "45.4339,11.2578",
        southwest: "45.4139,11.2378",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bad Dürkheim",
        long_name: "Bad Dürkheim",
        country: "Germany",
        latitud: 49.45997,
        longitud: 8.160059,
        northeast: "49.4700,8.1701",
        southwest: "49.4500,8.1501",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Varese Ligure",
        long_name: "Varese Ligure",
        country: "Italy",
        latitud: 44.3774,
        longitud: 9.593907,
        northeast: "44.3874,9.6039",
        southwest: "44.3674,9.5839",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Neuenstadt am Kocher",
        long_name: "Neuenstadt am Kocher",
        country: "Germany",
        latitud: 49.23012,
        longitud: 9.334677,
        northeast: "49.2401,9.3447",
        southwest: "49.2201,9.3247",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Maggio",
        long_name: "Maggio",
        country: "Italy",
        latitud: 45.92776,
        longitud: 9.46053,
        northeast: "45.9378,9.4705",
        southwest: "45.9178,9.4505",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Rosignano Solvay-Castiglioncello",
        long_name: "Rosignano Solvay-Castiglioncello",
        country: "Italy",
        latitud: 43.3932,
        longitud: 10.43542,
        northeast: "43.4032,10.4454",
        southwest: "43.3832,10.4254",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Santa Cruz de Tenerife",
        long_name: "Santa Cruz de Tenerife",
        country: "España",
        latitud: 28.02413,
        longitud: -16.60896,
        northeast: "28.0341,-16.5990",
        southwest: "28.0141,-16.6190",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Borgo Valsugana",
        long_name: "Borgo Valsugana",
        country: "Italy",
        latitud: 46.05426,
        longitud: 11.45803,
        northeast: "46.0643,11.4680",
        southwest: "46.0443,11.4480",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Galatone",
        long_name: "Galatone",
        country: "Italy",
        latitud: 40.14196,
        longitud: 18.07419,
        northeast: "40.1520,18.0842",
        southwest: "40.1320,18.0642",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sant'Antioco",
        long_name: "Sant'Antioco",
        country: "Italy",
        latitud: 39.05927,
        longitud: 8.455892,
        northeast: "39.0693,8.4659",
        southwest: "39.0493,8.4459",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Klütz",
        long_name: "Klütz",
        country: "Germany",
        latitud: 53.93776,
        longitud: 11.24508,
        northeast: "53.9478,11.2551",
        southwest: "53.9278,11.2351",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pitigliano",
        long_name: "Pitigliano",
        country: "Italy",
        latitud: 42.63418,
        longitud: 11.6665,
        northeast: "42.6442,11.6765",
        southwest: "42.6242,11.6565",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pozzillo",
        long_name: "Pozzillo",
        country: "Italy",
        latitud: 37.65824,
        longitud: 15.19535,
        northeast: "37.6682,15.2053",
        southwest: "37.6482,15.1853",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bad Zwischenahn",
        long_name: "Bad Zwischenahn",
        country: "Germany",
        latitud: 53.18042,
        longitud: 7.996599,
        northeast: "53.1904,8.0066",
        southwest: "53.1704,7.9866",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Erfurt",
        long_name: "Erfurt",
        country: "Germany",
        latitud: 50.9705,
        longitud: 11.01652,
        northeast: "50.9805,11.0265",
        southwest: "50.9605,11.0065",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Aachen",
        long_name: "Aachen",
        country: "Germany",
        latitud: 50.78454,
        longitud: 6.089753,
        northeast: "50.7945,6.0998",
        southwest: "50.7745,6.0798",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Estremoz",
        long_name: "Estremoz",
        country: "Portugal",
        // Ver el comentario de Pedrógão Grande: mismo caso.
        latitud: 38.8428,
        longitud: -7.5867,
        northeast: "38.9500,-7.4000",
        southwest: "38.7500,-7.7500",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Morlupo",
        long_name: "Morlupo",
        country: "Italy",
        latitud: 42.1451,
        longitud: 12.49261,
        northeast: "42.1551,12.5026",
        southwest: "42.1351,12.4826",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "St. Gallen",
        long_name: "St. Gallen",
        country: "Switzerland",
        latitud: 47.41476,
        longitud: 9.397921,
        northeast: "47.4248,9.4079",
        southwest: "47.4048,9.3879",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Barcelona (alrededores) 2",
        long_name: "Barcelona (alrededores) 2",
        country: "España",
        latitud: 41.30495,
        longitud: 2.000207,
        northeast: "41.3149,2.0102",
        southwest: "41.2950,1.9902",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lido Manfria",
        long_name: "Lido Manfria",
        country: "Italy",
        latitud: 37.09892,
        longitud: 14.14583,
        northeast: "37.1089,14.1558",
        southwest: "37.0889,14.1358",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ramatuelle",
        long_name: "Ramatuelle",
        country: "France",
        latitud: 43.2492,
        longitud: 6.664121,
        northeast: "43.2592,6.6741",
        southwest: "43.2392,6.6541",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bad Friedrichshall",
        long_name: "Bad Friedrichshall",
        country: "Germany",
        latitud: 49.25109,
        longitud: 9.196531,
        northeast: "49.2611,9.2065",
        southwest: "49.2411,9.1865",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Illes Balears 4",
        long_name: "Illes Balears 4",
        country: "España",
        latitud: 38.98646,
        longitud: 1.533668,
        northeast: "38.9965,1.5437",
        southwest: "38.9765,1.5237",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Álava",
        long_name: "Álava",
        country: "España",
        latitud: 42.84602,
        longitud: -2.673599,
        northeast: "42.8560,-2.6636",
        southwest: "42.8360,-2.6836",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Alicante (alrededores) 3",
        long_name: "Alicante (alrededores) 3",
        country: "España",
        latitud: 38.0857,
        longitud: -0.727526,
        northeast: "38.0957,-0.7175",
        southwest: "38.0757,-0.7375",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Golegã",
        long_name: "Golegã",
        country: "Portugal",
        latitud: 39.4034,
        longitud: -8.486573,
        northeast: "39.4134,-8.4766",
        southwest: "39.3934,-8.4966",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cala Gonone",
        long_name: "Cala Gonone",
        country: "Italy",
        latitud: 40.285,
        longitud: 9.630699,
        northeast: "40.2950,9.6407",
        southwest: "40.2750,9.6207",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Brescello",
        long_name: "Brescello",
        country: "Italy",
        latitud: 44.90075,
        longitud: 10.51343,
        northeast: "44.9108,10.5234",
        southwest: "44.8908,10.5034",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Basildon",
        long_name: "Basildon",
        country: "United-Kingdom",
        latitud: 51.57993,
        longitud: 0.492472,
        northeast: "51.5899,0.5025",
        southwest: "51.5699,0.4825",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Turi",
        long_name: "Turi",
        country: "Italy",
        latitud: 40.91554,
        longitud: 17.02201,
        northeast: "40.9255,17.0320",
        southwest: "40.9055,17.0120",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "San Giorgio delle Pertiche",
        long_name: "San Giorgio delle Pertiche",
        country: "Italy",
        latitud: 45.5419,
        longitud: 11.87558,
        northeast: "45.5519,11.8856",
        southwest: "45.5319,11.8656",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Faenza",
        long_name: "Faenza",
        country: "Italy",
        latitud: 44.29084,
        longitud: 11.86981,
        northeast: "44.3008,11.8798",
        southwest: "44.2808,11.8598",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Castelbuono",
        long_name: "Castelbuono",
        country: "Italy",
        latitud: 37.93133,
        longitud: 14.08916,
        northeast: "37.9413,14.0992",
        southwest: "37.9213,14.0792",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sondrio",
        long_name: "Sondrio",
        country: "Italy",
        latitud: 46.16757,
        longitud: 9.878105,
        northeast: "46.1776,9.8881",
        southwest: "46.1576,9.8681",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ulm",
        long_name: "Ulm",
        country: "Germany",
        latitud: 48.39331,
        longitud: 9.968427,
        northeast: "48.4033,9.9784",
        southwest: "48.3833,9.9584",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Abtenau",
        long_name: "Abtenau",
        country: "Austria",
        latitud: 47.59603,
        longitud: 13.31988,
        northeast: "47.6060,13.3299",
        southwest: "47.5860,13.3099",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Menton",
        long_name: "Menton",
        country: "France",
        latitud: 43.7792,
        longitud: 7.493926,
        northeast: "43.7892,7.5039",
        southwest: "43.7692,7.4839",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Saint-Gervais-les-Bains",
        long_name: "Saint-Gervais-les-Bains",
        country: "France",
        latitud: 45.90559,
        longitud: 6.703571,
        northeast: "45.9156,6.7136",
        southwest: "45.8956,6.6936",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Málaga (alrededores) 5",
        long_name: "Málaga (alrededores) 5",
        country: "España",
        latitud: 36.74535,
        longitud: -3.879661,
        northeast: "36.7553,-3.8697",
        southwest: "36.7354,-3.8897",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "FIUMALBO",
        long_name: "FIUMALBO",
        country: "Italy",
        latitud: 44.15524,
        longitud: 10.66353,
        northeast: "44.1652,10.6735",
        southwest: "44.1452,10.6535",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Beckedorf",
        long_name: "Beckedorf",
        country: "Germany",
        latitud: 52.34863,
        longitud: 9.314304,
        northeast: "52.3586,9.3243",
        southwest: "52.3386,9.3043",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ascea",
        long_name: "Ascea",
        country: "Italy",
        latitud: 40.14684,
        longitud: 15.16357,
        northeast: "40.1568,15.1736",
        southwest: "40.1368,15.1536",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Butzbach",
        long_name: "Butzbach",
        country: "Germany",
        latitud: 50.44408,
        longitud: 8.653437,
        northeast: "50.4541,8.6634",
        southwest: "50.4341,8.6434",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Sofia",
        long_name: "Sofia",
        country: "Bulgaria",
        latitud: 42.67634,
        longitud: 23.36236,
        northeast: "42.6863,23.3724",
        southwest: "42.6663,23.3524",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Cefalù",
        long_name: "Cefalù",
        country: "Italy",
        latitud: 38.02997,
        longitud: 14.03913,
        northeast: "38.0400,14.0491",
        southwest: "38.0200,14.0291",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Nicosia",
        long_name: "Nicosia",
        country: "Cyprus",
        latitud: 35.16447,
        longitud: 33.36736,
        northeast: "35.1745,33.3774",
        southwest: "35.1545,33.3574",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Castel Viscardo",
        long_name: "Castel Viscardo",
        country: "Italy",
        latitud: 42.75311,
        longitud: 11.99881,
        northeast: "42.7631,12.0088",
        southwest: "42.7431,11.9888",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "La Rochelle",
        long_name: "La Rochelle",
        country: "France",
        latitud: 46.15537,
        longitud: -1.143357,
        northeast: "46.1654,-1.1334",
        southwest: "46.1454,-1.1534",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Capoterra",
        long_name: "Capoterra",
        country: "Italy",
        latitud: 39.16962,
        longitud: 8.975801,
        northeast: "39.1796,8.9858",
        southwest: "39.1596,8.9658",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Milazzo",
        long_name: "Milazzo",
        country: "Italy",
        latitud: 38.22293,
        longitud: 15.24247,
        northeast: "38.2329,15.2525",
        southwest: "38.2129,15.2325",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Mönchengladbach",
        long_name: "Mönchengladbach",
        country: "Germany",
        latitud: 51.19062,
        longitud: 6.451544,
        northeast: "51.2006,6.4615",
        southwest: "51.1806,6.4415",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Marina di Ragusa",
        long_name: "Marina di Ragusa",
        country: "Italy",
        latitud: 36.7825,
        longitud: 14.53745,
        northeast: "36.7925,14.5474",
        southwest: "36.7725,14.5274",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Santa Cruz de Tenerife 2",
        long_name: "Santa Cruz de Tenerife 2",
        country: "España",
        latitud: 28.45976,
        longitud: -16.25577,
        northeast: "28.4698,-16.2458",
        southwest: "28.4498,-16.2658",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ala",
        long_name: "Ala",
        country: "Italy",
        latitud: 45.75576,
        longitud: 11.00597,
        northeast: "45.7658,11.0160",
        southwest: "45.7458,10.9960",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Heppenheim (Bergstraße)",
        long_name: "Heppenheim (Bergstraße)",
        country: "Germany",
        latitud: 49.63282,
        longitud: 8.628452,
        northeast: "49.6428,8.6385",
        southwest: "49.6228,8.6185",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "La Maddalena",
        long_name: "La Maddalena",
        country: "Italy",
        latitud: 41.22201,
        longitud: 9.429055,
        northeast: "41.2320,9.4391",
        southwest: "41.2120,9.4191",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Barcelona (alrededores) 3",
        long_name: "Barcelona (alrededores) 3",
        country: "España",
        latitud: 41.56599,
        longitud: 2.49112,
        northeast: "41.5760,2.5011",
        southwest: "41.5560,2.4811",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Görlitz",
        long_name: "Görlitz",
        country: "Germany",
        latitud: 51.15867,
        longitud: 14.99323,
        northeast: "51.1687,15.0032",
        southwest: "51.1487,14.9832",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "San Gregorio",
        long_name: "San Gregorio",
        country: "Italy",
        latitud: 39.3,
        longitud: 9.366232,
        northeast: "39.3100,9.3762",
        southwest: "39.2900,9.3562",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Krefeld",
        long_name: "Krefeld",
        country: "Germany",
        latitud: 51.33583,
        longitud: 6.642558,
        northeast: "51.3458,6.6526",
        southwest: "51.3258,6.6326",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Arnstadt",
        long_name: "Arnstadt",
        country: "Germany",
        latitud: 50.84362,
        longitud: 10.95034,
        northeast: "50.8536,10.9603",
        southwest: "50.8336,10.9403",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Hemhofen",
        long_name: "Hemhofen",
        country: "Germany",
        latitud: 49.68493,
        longitud: 10.94342,
        northeast: "49.6949,10.9534",
        southwest: "49.6749,10.9334",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Tutzing",
        long_name: "Tutzing",
        country: "Germany",
        latitud: 47.89811,
        longitud: 11.26366,
        northeast: "47.9081,11.2737",
        southwest: "47.8881,11.2537",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Gallipoli",
        long_name: "Gallipoli",
        country: "Italy",
        latitud: 40.0542,
        longitud: 17.97661,
        northeast: "40.0642,17.9866",
        southwest: "40.0442,17.9666",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Agliè",
        long_name: "Agliè",
        country: "Italy",
        latitud: 45.36495,
        longitud: 7.773283,
        northeast: "45.3749,7.7833",
        southwest: "45.3550,7.7633",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bad Homburg vor der Höhe",
        long_name: "Bad Homburg vor der Höhe",
        country: "Germany",
        latitud: 50.22869,
        longitud: 8.61684,
        northeast: "50.2387,8.6268",
        southwest: "50.2187,8.6068",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Landstuhl",
        long_name: "Landstuhl",
        country: "Germany",
        latitud: 49.40265,
        longitud: 7.568997,
        northeast: "49.4126,7.5790",
        southwest: "49.3927,7.5590",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "San Vito dei Normanni",
        long_name: "San Vito dei Normanni",
        country: "Italy",
        latitud: 40.66144,
        longitud: 17.70537,
        northeast: "40.6714,17.7154",
        southwest: "40.6514,17.6954",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Antegnate",
        long_name: "Antegnate",
        country: "Italy",
        latitud: 45.48811,
        longitud: 9.792289,
        northeast: "45.4981,9.8023",
        southwest: "45.4781,9.7823",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bretten",
        long_name: "Bretten",
        country: "Germany",
        latitud: 49.0333,
        longitud: 8.70584,
        northeast: "49.0433,8.7158",
        southwest: "49.0233,8.6958",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Nuoro",
        long_name: "Nuoro",
        country: "Italy",
        latitud: 40.32298,
        longitud: 9.319297,
        northeast: "40.3330,9.3293",
        southwest: "40.3130,9.3093",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Buchen (Odenwald)",
        long_name: "Buchen (Odenwald)",
        country: "Germany",
        latitud: 49.51654,
        longitud: 9.31445,
        northeast: "49.5265,9.3245",
        southwest: "49.5065,9.3045",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Dortmund",
        long_name: "Dortmund",
        country: "Germany",
        latitud: 51.4931,
        longitud: 7.503246,
        northeast: "51.5031,7.5132",
        southwest: "51.4831,7.4932",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Moncalieri",
        long_name: "Moncalieri",
        country: "Italy",
        latitud: 44.99901,
        longitud: 7.677807,
        northeast: "45.0090,7.6878",
        southwest: "44.9890,7.6678",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Hameln",
        long_name: "Hameln",
        country: "Germany",
        latitud: 52.10117,
        longitud: 9.358562,
        northeast: "52.1112,9.3686",
        southwest: "52.0912,9.3486",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Walldürn",
        long_name: "Walldürn",
        country: "Germany",
        latitud: 49.62266,
        longitud: 9.365341,
        northeast: "49.6327,9.3753",
        southwest: "49.6127,9.3553",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lübeck",
        long_name: "Lübeck",
        country: "Germany",
        latitud: 53.85732,
        longitud: 10.63882,
        northeast: "53.8673,10.6488",
        southwest: "53.8473,10.6288",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Arras",
        long_name: "Arras",
        country: "France",
        latitud: 50.28733,
        longitud: 2.792321,
        northeast: "50.2973,2.8023",
        southwest: "50.2773,2.7823",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Krumpendorf am Wörthersee",
        long_name: "Krumpendorf am Wörthersee",
        country: "Austria",
        latitud: 46.62098,
        longitud: 14.21196,
        northeast: "46.6310,14.2220",
        southwest: "46.6110,14.2020",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Lübeck 2",
        long_name: "Lübeck 2",
        country: "Germany",
        latitud: 53.94918,
        longitud: 10.85236,
        northeast: "53.9592,10.8624",
        southwest: "53.9392,10.8424",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Eberswalde-Finow",
        long_name: "Eberswalde-Finow",
        country: "Germany",
        latitud: 52.83441,
        longitud: 13.76339,
        northeast: "52.8444,13.7734",
        southwest: "52.8244,13.7534",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Seedorf",
        long_name: "Seedorf",
        country: "Germany",
        latitud: 53.62041,
        longitud: 10.86452,
        northeast: "53.6304,10.8745",
        southwest: "53.6104,10.8545",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Atenas",
        long_name: "Atenas",
        country: "Greece",
        latitud: 37.98508,
        longitud: 23.72475,
        northeast: "37.9951,23.7348",
        southwest: "37.9751,23.7147",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Chemnitz",
        long_name: "Chemnitz",
        country: "Germany",
        latitud: 50.83068,
        longitud: 12.91774,
        northeast: "50.8407,12.9277",
        southwest: "50.8207,12.9077",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Passau",
        long_name: "Passau",
        country: "Germany",
        latitud: 48.57347,
        longitud: 13.45793,
        northeast: "48.5835,13.4679",
        southwest: "48.5635,13.4479",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Mühlacker-Lomersheim",
        long_name: "Mühlacker-Lomersheim",
        country: "Germany",
        latitud: 48.93208,
        longitud: 8.864689,
        northeast: "48.9421,8.8747",
        southwest: "48.9221,8.8547",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Colmar",
        long_name: "Colmar",
        country: "France",
        latitud: 48.08474,
        longitud: 7.355407,
        northeast: "48.0947,7.3654",
        southwest: "48.0747,7.3454",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Saint-Étienne 2",
        long_name: "Saint-Étienne 2",
        country: "France",
        latitud: 46.89618,
        longitud: 6.365676,
        northeast: "46.9062,6.3757",
        southwest: "46.8862,6.3557",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Grasse",
        long_name: "Grasse",
        country: "France",
        latitud: 43.65359,
        longitud: 6.924952,
        northeast: "43.6636,6.9350",
        southwest: "43.6436,6.9150",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Winnenden",
        long_name: "Winnenden",
        country: "Germany",
        latitud: 48.87908,
        longitud: 9.38895,
        northeast: "48.8891,9.3989",
        southwest: "48.8691,9.3789",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Ovronnaz",
        long_name: "Ovronnaz",
        country: "Switzerland",
        latitud: 46.19687,
        longitud: 7.173525,
        northeast: "46.2069,7.1835",
        southwest: "46.1869,7.1635",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Hauzenberg",
        long_name: "Hauzenberg",
        country: "Germany",
        latitud: 48.62721,
        longitud: 13.5725,
        northeast: "48.6372,13.5825",
        southwest: "48.6172,13.5625",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Pantelleria",
        long_name: "Pantelleria",
        country: "Italy",
        latitud: 36.79753,
        longitud: 11.93723,
        northeast: "36.8075,11.9472",
        southwest: "36.7875,11.9272",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Bad Füssing-Egglfing a.Inn",
        long_name: "Bad Füssing-Egglfing a.Inn",
        country: "Germany",
        latitud: 48.32797,
        longitud: 13.313,
        northeast: "48.3380,13.3230",
        southwest: "48.3180,13.3030",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Moirans",
        long_name: "Moirans",
        country: "France",
        latitud: 45.32706,
        longitud: 5.565561,
        northeast: "45.3371,5.5756",
        southwest: "45.3171,5.5556",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Colfosco",
        long_name: "Colfosco",
        country: "Italy",
        latitud: 46.55516,
        longitud: 11.85598,
        northeast: "46.5652,11.8660",
        southwest: "46.5452,11.8460",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Joué-lès-Tours",
        long_name: "Joué-lès-Tours",
        country: "France",
        latitud: 47.34037,
        longitud: 0.627122,
        northeast: "47.3504,0.6371",
        southwest: "47.3304,0.6171",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    },
    {
        comuna: "Besançon",
        long_name: "Besançon",
        country: "France",
        latitud: 47.24543,
        longitud: 5.99829,
        northeast: "47.2554,6.0083",
        southwest: "47.2354,5.9883",
        polygon: false,
        image_filename: "default",
        search_query_enabled: false
    }
];
